export const IAB_ORG = [{
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1",
   "name": "Automotive"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.1",
   "name": "Auto Body Styles",
   "parent": "Automotive"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.1.1",
   "name": "Commercial Trucks",
   "parent": "Auto Body Styles"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.1.10",
   "name": "Sedan",
   "parent": "Auto Body Styles"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.1.11",
   "name": "Station Wagon",
   "parent": "Auto Body Styles"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.1.12",
   "name": "SUV",
   "parent": "Auto Body Styles"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.1.13",
   "name": "Van",
   "parent": "Auto Body Styles"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.1.2",
   "name": "Convertible",
   "parent": "Auto Body Styles"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.1.3",
   "name": "Coupe",
   "parent": "Auto Body Styles"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.1.4",
   "name": "Crossover",
   "parent": "Auto Body Styles"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.1.5",
   "name": "Hatchback",
   "parent": "Auto Body Styles"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.1.6",
   "name": "Microcar",
   "parent": "Auto Body Styles"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.1.7",
   "name": "Minivan",
   "parent": "Auto Body Styles"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.1.8",
   "name": "Off-Road Vehicles",
   "parent": "Auto Body Styles"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.1.9",
   "name": "Pickup Trucks",
   "parent": "Auto Body Styles"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.1",
   "name": "Auto Type",
   "parent": "Automotive"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.10.1",
   "name": "Budget Cars",
   "parent": "Auto Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.10.2",
   "name": "Certified Pre-Owned Cars",
   "parent": "Auto Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.10.3",
   "name": "Classic Cars",
   "parent": "Auto Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.10.4",
   "name": "Concept Cars",
   "parent": "Auto Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.10.5",
   "name": "Driverless Cars",
   "parent": "Auto Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.10.6",
   "name": "Green Vehicles",
   "parent": "Auto Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.11",
   "name": "Car Culture",
   "parent": "Automotive"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.12",
   "name": "Dash Cam Videos",
   "parent": "Automotive"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.13",
   "name": "Motorcycles",
   "parent": "Automotive"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.14",
   "name": "Road-Side Assistance",
   "parent": "Automotive"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.15",
   "name": "Scooters",
   "parent": "Automotive"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.2",
   "name": "Auto Buying and Selling",
   "parent": "Automotive"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.3",
   "name": "Auto Insurance",
   "parent": "Automotive"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.4",
   "name": "Auto Parts",
   "parent": "Automotive"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.5",
   "name": "Auto Recalls",
   "parent": "Automotive"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.6",
   "name": "Auto Repair",
   "parent": "Automotive"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.7",
   "name": "Auto Safety",
   "parent": "Automotive"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.8",
   "name": "Auto Shows",
   "parent": "Automotive"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.9",
   "name": "Auto Technology",
   "parent": "Automotive"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.9.1",
   "name": "Auto Infotainment Technologies",
   "parent": "Auto Technology"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.9.2",
   "name": "Auto Navigation Systems",
   "parent": "Auto Technology"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "1.9.3",
   "name": "Auto Safety Technologies",
   "parent": "Auto Technology"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "2",
   "name": "Books and Literature"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "2.1",
   "name": "Art and Photography Books",
   "parent": "Books and Literature"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "2.2",
   "name": "Biographies",
   "parent": "Books and Literature"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "2.3",
   "name": "Children's Literature",
   "parent": "Books and Literature"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "2.4",
   "name": "Comics and Graphic Novels",
   "parent": "Books and Literature"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "2.5",
   "name": "Cookbooks",
   "parent": "Books and Literature"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "2.6",
   "name": "Fiction",
   "parent": "Books and Literature"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "2.7",
   "name": "Poetry",
   "parent": "Books and Literature"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "2.8",
   "name": "Travel Books",
   "parent": "Books and Literature"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "2.9",
   "name": "Young Adult Literature",
   "parent": "Books and Literature"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3",
   "name": "Business and Finance"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.1",
   "name": "Business",
   "parent": "Business and Finance"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.1.1",
   "name": "Business Accounting & Finance",
   "parent": "Business"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.1.10",
   "name": "Human Resources",
   "parent": "Business"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.1.11",
   "name": "Large Business",
   "parent": "Business"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.1.12",
   "name": "Logistics",
   "parent": "Business"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.1.13",
   "name": "Marketing and Advertising",
   "parent": "Business"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.1.14",
   "name": "Sales",
   "parent": "Business"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.1.15",
   "name": "Small and Medium-sized Business",
   "parent": "Business"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.1.16",
   "name": "Startups",
   "parent": "Business"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.1.2",
   "name": "Business Administration",
   "parent": "Business"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.1.3",
   "name": "Business Banking & Finance",
   "parent": "Business"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.1.3.1",
   "name": "Angel Investment",
   "parent": "Business Banking & Finance"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.1.3.2",
   "name": "Bankruptcy",
   "parent": "Business Banking & Finance"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.1.3.3",
   "name": "Business Loans",
   "parent": "Business Banking & Finance"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.1.3.4",
   "name": "Debt Factoring & Invoice Discounting",
   "parent": "Business Banking & Finance"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.1.3.5",
   "name": "Mergers and Acquisitions",
   "parent": "Business Banking & Finance"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.1.3.6",
   "name": "Private Equity",
   "parent": "Business Banking & Finance"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.1.3.7",
   "name": "Sale & Lease Back",
   "parent": "Business Banking & Finance"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.1.3.8",
   "name": "Venture Capital",
   "parent": "Business Banking & Finance"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.1.4",
   "name": "Business I.T.",
   "parent": "Business"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.1.5",
   "name": "Business Operations",
   "parent": "Business"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.1.6",
   "name": "Consumer Issues",
   "parent": "Business"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.1.6.1",
   "name": "Recalls",
   "parent": "Consumer Issues"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.1.7",
   "name": "Executive Leadership & Management",
   "parent": "Business"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.1.8",
   "name": "Government Business",
   "parent": "Business"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.1.9",
   "name": "Green Solutions",
   "parent": "Business"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.2",
   "name": "Economy",
   "parent": "Business and Finance"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.2.1",
   "name": "Commodities",
   "parent": "Economy"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.2.2",
   "name": "Currencies",
   "parent": "Economy"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.2.3",
   "name": "Financial Crisis",
   "parent": "Economy"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.2.4",
   "name": "Financial Reform",
   "parent": "Economy"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.2.5",
   "name": "Financial Regulation",
   "parent": "Economy"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.2.6",
   "name": "Gasoline Prices",
   "parent": "Economy"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.2.7",
   "name": "Housing Market",
   "parent": "Economy"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.2.8",
   "name": "Interest Rates",
   "parent": "Economy"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.2.9",
   "name": "Job Market",
   "parent": "Economy"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3",
   "name": "Industries",
   "parent": "Business and Finance"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.1",
   "name": "Advertising Industry",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.10",
   "name": "Education industry",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.11",
   "name": "Entertainment Industry",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.12",
   "name": "Environmental Services Industry",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.13",
   "name": "Financial Industry",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.14",
   "name": "Food Industry",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.15",
   "name": "Healthcare Industry",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.16",
   "name": "Hospitality Industry",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.17",
   "name": "Information Services Industry",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.18",
   "name": "Legal Services Industry",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.19",
   "name": "Logistics and Transportation Industry",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.2",
   "name": "Agriculture",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.20",
   "name": "Management Consulting Industry",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.21",
   "name": "Manufacturing Industry",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.22",
   "name": "Mechanical and Industrial Engineering Industry",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.23",
   "name": "Media Industry",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.24",
   "name": "Metals Industry",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.25",
   "name": "Non-Profit Organizations",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.26",
   "name": "Pharmaceutical Industry",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.27",
   "name": "Power and Energy Industry",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.28",
   "name": "Publishing Industry",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.29",
   "name": "Real Estate Industry",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.3",
   "name": "Apparel Industry",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.30",
   "name": "Retail Industry",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.31",
   "name": "Technology Industry",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.32",
   "name": "Telecommunications Industry",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.4",
   "name": "Automotive Industry",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.5",
   "name": "Aviation Industry",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.6",
   "name": "Biotech and Biomedical Industry",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.7",
   "name": "Civil Engineering Industry",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.8",
   "name": "Construction Industry",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "3.3.9",
   "name": "Defense Industry",
   "parent": "Industries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "4",
   "name": "Careers"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "4.1",
   "name": "Apprenticeships",
   "parent": "Careers"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "4.2",
   "name": "Career Advice",
   "parent": "Careers"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "4.3",
   "name": "Career Planning",
   "parent": "Careers"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "4.4",
   "name": "Job Search",
   "parent": "Careers"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "4.4.1",
   "name": "Job Fairs",
   "parent": "Job Search"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "4.4.2",
   "name": "Resume Writing and Advice",
   "parent": "Job Search"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "4.5",
   "name": "Telecommuting",
   "parent": "Careers"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "4.6",
   "name": "Vocational Training",
   "parent": "Careers"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "5",
   "name": "Education"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "5.1",
   "name": "Adult Education",
   "parent": "Education"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "5.1",
   "name": "Private School",
   "parent": "Education"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "5.11",
   "name": "Secondary Education",
   "parent": "Education"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "5.12",
   "name": "Special Education",
   "parent": "Education"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "5.2",
   "name": "College Education",
   "parent": "Education"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "5.2.1",
   "name": "College Planning",
   "parent": "College Education"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "5.2.2",
   "name": "Postgraduate Education",
   "parent": "College Education"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "5.2.2.1",
   "name": "Professional School",
   "parent": "Postgraduate Education"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "5.2.3",
   "name": "Undergraduate Education",
   "parent": "College Education"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "5.3",
   "name": "Early Childhood Education",
   "parent": "Education"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "5.4",
   "name": "Educational Assessment",
   "parent": "Education"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "5.4.1",
   "name": "Standardized Testing",
   "parent": "Educational Assessment"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "5.5",
   "name": "Homeschooling",
   "parent": "Education"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "5.6",
   "name": "Homework and Study",
   "parent": "Education"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "5.7",
   "name": "Language Learning",
   "parent": "Education"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "5.8",
   "name": "Online Education",
   "parent": "Education"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "5.9",
   "name": "Primary Education",
   "parent": "Education"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6",
   "name": "Events and Attractions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.1",
   "name": "Amusement and Theme Parks",
   "parent": "Events and Attractions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.1",
   "name": "Fashion Events",
   "parent": "Events and Attractions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.11",
   "name": "Historic Site and Landmark Tours",
   "parent": "Events and Attractions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.12",
   "name": "Malls & Shopping Centers",
   "parent": "Events and Attractions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.13",
   "name": "Museums & Galleries",
   "parent": "Events and Attractions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.14",
   "name": "Musicals",
   "parent": "Events and Attractions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.15",
   "name": "National & Civic Holidays",
   "parent": "Events and Attractions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.16",
   "name": "Nightclubs",
   "parent": "Events and Attractions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.17",
   "name": "Outdoor Activities",
   "parent": "Events and Attractions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.18",
   "name": "Parks & Nature",
   "parent": "Events and Attractions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.19",
   "name": "Party Supplies and Decorations",
   "parent": "Events and Attractions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.2",
   "name": "Awards Shows",
   "parent": "Events and Attractions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.2",
   "name": "Personal Celebrations & Life Events",
   "parent": "Events and Attractions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.20.1",
   "name": "Anniversary",
   "parent": "Personal Celebrations & Life Events"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.20.10",
   "name": "Wedding",
   "parent": "Personal Celebrations & Life Events"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.20.2",
   "name": "Baby Shower",
   "parent": "Personal Celebrations & Life Events"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.20.3",
   "name": "Bachelor Party",
   "parent": "Personal Celebrations & Life Events"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.20.4",
   "name": "Bachelorette Party",
   "parent": "Personal Celebrations & Life Events"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.20.5",
   "name": "Birth",
   "parent": "Personal Celebrations & Life Events"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.20.6",
   "name": "Birthday",
   "parent": "Personal Celebrations & Life Events"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.20.7",
   "name": "Funeral",
   "parent": "Personal Celebrations & Life Events"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.20.8",
   "name": "Graduation",
   "parent": "Personal Celebrations & Life Events"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.20.9",
   "name": "Prom",
   "parent": "Personal Celebrations & Life Events"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.21",
   "name": "Political Event",
   "parent": "Events and Attractions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.22",
   "name": "Religious Events",
   "parent": "Events and Attractions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.23",
   "name": "Sporting Events",
   "parent": "Events and Attractions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.24",
   "name": "Theater Venues and Events",
   "parent": "Events and Attractions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.25",
   "name": "Zoos & Aquariums",
   "parent": "Events and Attractions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.3",
   "name": "Bars & Restaurants",
   "parent": "Events and Attractions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.4",
   "name": "Business Expos & Conferences",
   "parent": "Events and Attractions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.5",
   "name": "Casinos & Gambling",
   "parent": "Events and Attractions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.6",
   "name": "Cinemas and Events",
   "parent": "Events and Attractions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.7",
   "name": "Comedy Events",
   "parent": "Events and Attractions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.8",
   "name": "Concerts & Music Events",
   "parent": "Events and Attractions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "6.9",
   "name": "Fan Conventions",
   "parent": "Events and Attractions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "7",
   "name": "Family and Relationships"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "7.1",
   "name": "Bereavement",
   "parent": "Family and Relationships"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "7.2",
   "name": "Dating",
   "parent": "Family and Relationships"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "7.3",
   "name": "Divorce",
   "parent": "Family and Relationships"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "7.4",
   "name": "Eldercare",
   "parent": "Family and Relationships"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "7.5",
   "name": "Marriage and Civil Unions",
   "parent": "Family and Relationships"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "7.6",
   "name": "Parenting",
   "parent": "Family and Relationships"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "7.6.1",
   "name": "Adoption and Fostering",
   "parent": "Parenting"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "7.6.2",
   "name": "Daycare and Pre-School",
   "parent": "Parenting"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "7.6.3",
   "name": "Internet Safety",
   "parent": "Parenting"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "7.6.4",
   "name": "Parenting Babies and Toddlers",
   "parent": "Parenting"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "7.6.5",
   "name": "Parenting Children Aged 4-11",
   "parent": "Parenting"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "7.6.6",
   "name": "Parenting Teens",
   "parent": "Parenting"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "7.6.7",
   "name": "Pregnancy",
   "parent": "Parenting"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "7.6.8",
   "name": "Special Needs Kids",
   "parent": "Parenting"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "7.7",
   "name": "Single Life",
   "parent": "Family and Relationships"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "8",
   "name": "Fine Art"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "8.1",
   "name": "Costume",
   "parent": "Fine Art"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "8.2",
   "name": "Dance",
   "parent": "Fine Art"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "8.3",
   "name": "Design",
   "parent": "Fine Art"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "8.4",
   "name": "Digital Arts",
   "parent": "Fine Art"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "8.5",
   "name": "Fine Art Photography",
   "parent": "Fine Art"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "8.6",
   "name": "Fine Art Photography",
   "parent": "Fine Art"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "8.7",
   "name": "Modern Art",
   "parent": "Fine Art"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "8.8",
   "name": "Opera",
   "parent": "Fine Art"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "8.9",
   "name": "Theater",
   "parent": "Fine Art"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "9",
   "name": "Food & Drink"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "9.1",
   "name": "Alcoholic Beverages",
   "parent": "Food & Drink"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "9.1",
   "name": "Vegan Diets",
   "parent": "Food & Drink"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "9.11",
   "name": "Vegetarian Diets",
   "parent": "Food & Drink"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "9.12",
   "name": "World Cuisines",
   "parent": "Food & Drink"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "9.2",
   "name": "Barbecues and Grilling",
   "parent": "Food & Drink"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "9.3",
   "name": "Cooking",
   "parent": "Food & Drink"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "9.4",
   "name": "Desserts and Baking",
   "parent": "Food & Drink"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "9.5",
   "name": "Dining Out",
   "parent": "Food & Drink"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "9.6",
   "name": "Food Allergies",
   "parent": "Food & Drink"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "9.7",
   "name": "Food Movements",
   "parent": "Food & Drink"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "9.8",
   "name": "Healthy Cooking and Eating",
   "parent": "Food & Drink"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "9.9",
   "name": "Non-Alcoholic Beverages",
   "parent": "Food & Drink"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "10",
   "name": "Healthy Living"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "10.1",
   "name": "Children's Health",
   "parent": "Healthy Living"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "10.2",
   "name": "Fitness and Exercise",
   "parent": "Healthy Living"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "10.2.1",
   "name": "Participant Sports",
   "parent": "Fitness and Exercise"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "10.2.2",
   "name": "Running and Jogging",
   "parent": "Fitness and Exercise"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "10.3",
   "name": "Men's Health",
   "parent": "Healthy Living"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "10.4",
   "name": "Nutrition",
   "parent": "Healthy Living"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "10.5",
   "name": "Senior Health",
   "parent": "Healthy Living"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "10.6",
   "name": "Weight Loss",
   "parent": "Healthy Living"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "10.7",
   "name": "Wellness",
   "parent": "Healthy Living"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "10.7.1",
   "name": "Alternative Medicine",
   "parent": "Wellness"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "10.7.2",
   "name": "Physical Therapy",
   "parent": "Wellness"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "10.7.3",
   "name": "Smoking Cessation",
   "parent": "Wellness"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "10.8",
   "name": "Women's Health",
   "parent": "Healthy Living"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11",
   "name": "Hobbies & Interests"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.1",
   "name": "Antiquing and Antiques",
   "parent": "Hobbies & Interests"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.1",
   "name": "Magic and Illusion",
   "parent": "Hobbies & Interests"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.11",
   "name": "Model Toys",
   "parent": "Hobbies & Interests"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.12",
   "name": "Musical Instruments",
   "parent": "Hobbies & Interests"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.13",
   "name": "Paranormal Phenomena",
   "parent": "Hobbies & Interests"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.14",
   "name": "Radio Control",
   "parent": "Hobbies & Interests"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.15",
   "name": "Sci-fi and Fantasy",
   "parent": "Hobbies & Interests"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.16",
   "name": "Workshops and Classes",
   "parent": "Hobbies & Interests"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.2",
   "name": "Arts and Crafts",
   "parent": "Hobbies & Interests"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.2.1",
   "name": "Beadwork",
   "parent": "Arts and Crafts"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.2.2",
   "name": "Candle and Soap Making",
   "parent": "Arts and Crafts"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.2.3",
   "name": "Drawing and Sketching",
   "parent": "Arts and Crafts"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.2.4",
   "name": "Jewelry Making",
   "parent": "Arts and Crafts"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.2.5",
   "name": "Needlework",
   "parent": "Arts and Crafts"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.2.6",
   "name": "Painting",
   "parent": "Arts and Crafts"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.2.7",
   "name": "Photography",
   "parent": "Arts and Crafts"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.2.8",
   "name": "Scrapbooking",
   "parent": "Arts and Crafts"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.2.9",
   "name": "Woodworking",
   "parent": "Arts and Crafts"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.3",
   "name": "Beekeeping",
   "parent": "Hobbies & Interests"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.4",
   "name": "Birdwatching",
   "parent": "Hobbies & Interests"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.5",
   "name": "Cigars",
   "parent": "Hobbies & Interests"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.6",
   "name": "Collecting",
   "parent": "Hobbies & Interests"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.6.1",
   "name": "Comic Books",
   "parent": "Collecting"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.6.2",
   "name": "Stamps and Coins",
   "parent": "Collecting"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.7",
   "name": "Content Production",
   "parent": "Hobbies & Interests"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.7.1",
   "name": "Audio Production",
   "parent": "Content Production"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.7.2",
   "name": "Freelance Writing",
   "parent": "Content Production"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.7.3",
   "name": "Screenwriting",
   "parent": "Content Production"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.7.4",
   "name": "Video Production",
   "parent": "Content Production"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.8",
   "name": "Games and Puzzles",
   "parent": "Hobbies & Interests"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.8.1",
   "name": "Board Games and Puzzles",
   "parent": "Games and Puzzles"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.8.2",
   "name": "Card Games",
   "parent": "Games and Puzzles"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.8.3",
   "name": "Roleplaying Games",
   "parent": "Games and Puzzles"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "11.9",
   "name": "Genealogy and Ancestry",
   "parent": "Hobbies & Interests"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "12",
   "name": "Home & Garden"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "12.1",
   "name": "Gardening",
   "parent": "Home & Garden"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "12.1",
   "name": "Remodeling & Construction",
   "parent": "Home & Garden"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "12.11",
   "name": "Smart Home",
   "parent": "Home & Garden"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "12.2",
   "name": "Home Appliances",
   "parent": "Home & Garden"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "12.3",
   "name": "Home Entertaining",
   "parent": "Home & Garden"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "12.4",
   "name": "Home Improvement",
   "parent": "Home & Garden"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "12.5",
   "name": "Home Security",
   "parent": "Home & Garden"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "12.6",
   "name": "Indoor Environmental Quality",
   "parent": "Home & Garden"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "12.7",
   "name": "Interior Decorating",
   "parent": "Home & Garden"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "12.8",
   "name": "Landscaping",
   "parent": "Home & Garden"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "12.9",
   "name": "Outdoor Decorating",
   "parent": "Home & Garden"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13",
   "name": "Medical Health"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1",
   "name": "Diseases and Conditions",
   "parent": "Medical Health"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1.1",
   "name": "Allergies",
   "parent": "Diseases and Conditions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1.10",
   "name": "Ear, Nose and Throat Conditions",
   "parent": "Diseases and Conditions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1.11",
   "name": "Endocrine and Metabolic Diseases",
   "parent": "Diseases and Conditions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1.11.1",
   "name": "Hormonal Disorders",
   "parent": "Endocrine and Metabolic Diseases"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1.11.2",
   "name": "Menopause",
   "parent": "Endocrine and Metabolic Diseases"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1.11.3",
   "name": "Thyroid Disorders",
   "parent": "Endocrine and Metabolic Diseases"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1.12",
   "name": "Eye and Vision Conditions",
   "parent": "Diseases and Conditions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1.13",
   "name": "Foot Health",
   "parent": "Diseases and Conditions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1.14",
   "name": "Heart and Cardiovascular Diseases",
   "parent": "Diseases and Conditions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1.15",
   "name": "Infectious Diseases",
   "parent": "Diseases and Conditions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1.16",
   "name": "Injuries",
   "parent": "Diseases and Conditions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1.16.1",
   "name": "First Aid",
   "parent": "Injuries"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1.17",
   "name": "Lung and Respiratory Health",
   "parent": "Diseases and Conditions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1.18",
   "name": "Mental Health",
   "parent": "Diseases and Conditions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1.19",
   "name": "Reproductive Health",
   "parent": "Diseases and Conditions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1.19.1",
   "name": "Birth Control",
   "parent": "Reproductive Health"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1.19.2",
   "name": "Infertility",
   "parent": "Reproductive Health"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1.19.3",
   "name": "Pregnancy",
   "parent": "Reproductive Health"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1.2",
   "name": "Blood Disorders",
   "parent": "Diseases and Conditions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1.20",
   "name": "Sexual Health",
   "parent": "Diseases and Conditions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1.20.1",
   "name": "Sexual Conditions",
   "parent": "Sexual Health"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1.21",
   "name": "Skin and Dermatology",
   "parent": "Diseases and Conditions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1.22",
   "name": "Sleep Disorders",
   "parent": "Diseases and Conditions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1.23",
   "name": "Substance Abuse",
   "parent": "Diseases and Conditions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1.3",
   "name": "Bone and Joint Conditions",
   "parent": "Diseases and Conditions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1.4",
   "name": "Brain and Nervous System Disorders",
   "parent": "Diseases and Conditions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1.5",
   "name": "Cancer",
   "parent": "Diseases and Conditions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1.6",
   "name": "Cold and Flu",
   "parent": "Diseases and Conditions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1.7",
   "name": "Dental Health",
   "parent": "Diseases and Conditions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1.8",
   "name": "Diabetes",
   "parent": "Diseases and Conditions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.1.9",
   "name": "Digestive Disorders",
   "parent": "Diseases and Conditions"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.2",
   "name": "Medical Tests",
   "parent": "Medical Health"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.3",
   "name": "Pharmaceutical Drugs",
   "parent": "Medical Health"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.4",
   "name": "Surgery",
   "parent": "Medical Health"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "13.5",
   "name": "Vaccines",
   "parent": "Medical Health"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "14",
   "name": "Movies"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "14.1",
   "name": "Action and Adventure Movies",
   "parent": "Movies"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "14.1",
   "name": "Romance Movies",
   "parent": "Movies"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "14.11",
   "name": "Science Fiction Movies",
   "parent": "Movies"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "14.12",
   "name": "Special Interest Movies",
   "parent": "Movies"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "14.2",
   "name": "Animation Movies",
   "parent": "Movies"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "14.3",
   "name": "Comedy Movies",
   "parent": "Movies"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "14.4",
   "name": "Crime and Mystery Movies",
   "parent": "Movies"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "14.5",
   "name": "Documentary Movies",
   "parent": "Movies"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "14.6",
   "name": "Drama Movies",
   "parent": "Movies"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "14.7",
   "name": "Family and Children Movies",
   "parent": "Movies"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "14.8",
   "name": "Fantasy Movies",
   "parent": "Movies"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "14.9",
   "name": "Horror Movies",
   "parent": "Movies"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15",
   "name": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.1",
   "name": "Adult Contemporary Music",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.1",
   "name": "Comedy Podcasts",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.11",
   "name": "Comedy Radio",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.12",
   "name": "Contemporary Hits",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.13",
   "name": "Country Music",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.14",
   "name": "Dance and Electronic Music",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.15",
   "name": "Education Podcasts",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.16",
   "name": "Folk Music",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.17",
   "name": "Games & Hobbies Podcasts",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.18",
   "name": "Gospel Music",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.19",
   "name": "Health Podcasts",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.2",
   "name": "Arts Podcasts",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.2",
   "name": "Hip Hop Music",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.21",
   "name": "Inspirational Music",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.22",
   "name": "International Music",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.23",
   "name": "Jazz",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.24",
   "name": "Kids & Family Podcasts",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.25",
   "name": "News & Politics Podcasts",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.26",
   "name": "Oldies Music",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.27",
   "name": "Public Radio",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.28",
   "name": "Reggae",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.29",
   "name": "Religion & Spirituality Podcasts",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.3",
   "name": "Blues",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.3",
   "name": "Religious Music",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.31",
   "name": "Rhythm and Blues",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.32",
   "name": "Rock Music",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.32.1",
   "name": "Album-oriented Rock",
   "parent": "Rock Music"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.32.2",
   "name": "Alternative Rock",
   "parent": "Rock Music"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.32.3",
   "name": "Classic Rock",
   "parent": "Rock Music"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.32.4",
   "name": "Hard Rock",
   "parent": "Rock Music"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.33",
   "name": "Science & Medicine Podcasts",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.34",
   "name": "Society & Culture Podcasts",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.35",
   "name": "Soundtracks",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.36",
   "name": "Sports & Recreation Podcasts",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.37",
   "name": "Sports Play-by-Play",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.38",
   "name": "Sports Talk Radio",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.39",
   "name": "Talk Radio",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.39.1",
   "name": "All-news radio",
   "parent": "Talk Radio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.39.2",
   "name": "Educational Radio",
   "parent": "Talk Radio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.39.3",
   "name": "News/Talk",
   "parent": "Talk Radio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.4",
   "name": "Business News Radio",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.4",
   "name": "Technology Podcasts",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.41",
   "name": "TV & Film Podcasts",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.42",
   "name": "Urban Adult Contemporary Music",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.43",
   "name": "Urban Contemporary Music",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.5",
   "name": "Business Podcasts",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.6",
   "name": "Children's Music",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.7",
   "name": "Classic Hits",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.8",
   "name": "Classical Music",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "15.9",
   "name": "College Radio",
   "parent": "Music and Audio"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "16",
   "name": "News and Politics"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "16.1",
   "name": "Crime",
   "parent": "News and Politics"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "16.2",
   "name": "Disasters",
   "parent": "News and Politics"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "16.3",
   "name": "International News",
   "parent": "News and Politics"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "16.4",
   "name": "Law",
   "parent": "News and Politics"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "16.5",
   "name": "Local News",
   "parent": "News and Politics"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "16.6",
   "name": "National News",
   "parent": "News and Politics"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "16.7",
   "name": "Politics",
   "parent": "News and Politics"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "16.7.1",
   "name": "Elections",
   "parent": "Politics"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "16.7.2",
   "name": "Political Issues",
   "parent": "Politics"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "16.7.3",
   "name": "War and Conflicts",
   "parent": "Politics"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "16.8",
   "name": "Weather",
   "parent": "News and Politics"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "17",
   "name": "Personal Finance"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "17.1",
   "name": "Consumer Banking",
   "parent": "Personal Finance"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "17.2",
   "name": "Financial Assistance",
   "parent": "Personal Finance"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "17.2.1",
   "name": "Government Support and Welfare",
   "parent": "Financial Assistance"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "17.2.2",
   "name": "Student Financial Aid",
   "parent": "Financial Assistance"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "17.3",
   "name": "Financial Planning",
   "parent": "Personal Finance"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "17.4",
   "name": "Frugal Living",
   "parent": "Personal Finance"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "17.5",
   "name": "Insurance",
   "parent": "Personal Finance"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "17.5.1",
   "name": "Health Insurance",
   "parent": "Insurance"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "17.5.2",
   "name": "Home Insurance",
   "parent": "Insurance"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "17.5.3",
   "name": "Life Insurance",
   "parent": "Insurance"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "17.5.4",
   "name": "Motor Insurance",
   "parent": "Insurance"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "17.5.5",
   "name": "Pet Insurance",
   "parent": "Insurance"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "17.5.6",
   "name": "Travel Insurance",
   "parent": "Insurance"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "17.6",
   "name": "Personal Debt",
   "parent": "Personal Finance"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "17.6.1",
   "name": "Credit Cards",
   "parent": "Personal Debt"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "17.6.2",
   "name": "Home Financing",
   "parent": "Personal Debt"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "17.6.3",
   "name": "Personal Loans",
   "parent": "Personal Debt"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "17.6.4",
   "name": "Student Loans",
   "parent": "Personal Debt"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "17.7",
   "name": "Personal Investing",
   "parent": "Personal Finance"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "17.7.1",
   "name": "Hedge Funds",
   "parent": "Personal Investing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "17.7.2",
   "name": "Mutual Funds",
   "parent": "Personal Investing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "17.7.3",
   "name": "Options",
   "parent": "Personal Investing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "17.7.4",
   "name": "Stocks and Bonds",
   "parent": "Personal Investing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "17.8",
   "name": "Personal Taxes",
   "parent": "Personal Finance"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "17.9",
   "name": "Retirement Planning",
   "parent": "Personal Finance"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "18",
   "name": "Pets"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "18.1",
   "name": "Birds",
   "parent": "Pets"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "18.2",
   "name": "Cats",
   "parent": "Pets"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "18.3",
   "name": "Dogs",
   "parent": "Pets"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "18.4",
   "name": "Fish and Aquariums",
   "parent": "Pets"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "18.5",
   "name": "Large Animals",
   "parent": "Pets"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "18.6",
   "name": "Pet Adoptions",
   "parent": "Pets"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "18.7",
   "name": "Reptiles",
   "parent": "Pets"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "18.8",
   "name": "Veterinary Medicine",
   "parent": "Pets"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "19",
   "name": "Pop Culture"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "19.1",
   "name": "Celebrity Deaths",
   "parent": "Pop Culture"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "19.2",
   "name": "Celebrity Families",
   "parent": "Pop Culture"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "19.3",
   "name": "Celebrity Homes",
   "parent": "Pop Culture"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "19.4",
   "name": "Celebrity Pregnancy",
   "parent": "Pop Culture"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "19.5",
   "name": "Celebrity Relationships",
   "parent": "Pop Culture"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "19.6",
   "name": "Celebrity Scandal",
   "parent": "Pop Culture"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "19.7",
   "name": "Celebrity Style",
   "parent": "Pop Culture"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "20",
   "name": "Real Estate"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "20.1",
   "name": "Apartments",
   "parent": "Real Estate"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "20.1",
   "name": "Retail Property",
   "parent": "Real Estate"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "20.11",
   "name": "Vacation Properties",
   "parent": "Real Estate"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "20.2",
   "name": "Developmental Sites",
   "parent": "Real Estate"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "20.3",
   "name": "Hotel Properties",
   "parent": "Real Estate"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "20.4",
   "name": "Houses",
   "parent": "Real Estate"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "20.5",
   "name": "Industrial Property",
   "parent": "Real Estate"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "20.6",
   "name": "Land and Farms",
   "parent": "Real Estate"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "20.7",
   "name": "Office Property",
   "parent": "Real Estate"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "20.8",
   "name": "Real Estate Buying and Selling",
   "parent": "Real Estate"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "20.9",
   "name": "Real Estate Renting and Leasing",
   "parent": "Real Estate"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "21",
   "name": "Religion & Spirituality"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "21.1",
   "name": "Agnosticism",
   "parent": "Religion & Spirituality"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "21.1",
   "name": "Spirituality",
   "parent": "Religion & Spirituality"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "21.2",
   "name": "Astrology",
   "parent": "Religion & Spirituality"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "21.3",
   "name": "Atheism",
   "parent": "Religion & Spirituality"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "21.4",
   "name": "Buddhism",
   "parent": "Religion & Spirituality"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "21.5",
   "name": "Christianity",
   "parent": "Religion & Spirituality"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "21.6",
   "name": "Hinduism",
   "parent": "Religion & Spirituality"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "21.7",
   "name": "Islam",
   "parent": "Religion & Spirituality"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "21.8",
   "name": "Judaism",
   "parent": "Religion & Spirituality"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "21.9",
   "name": "Sikhism",
   "parent": "Religion & Spirituality"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "22",
   "name": "Science"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "22.1",
   "name": "Biological Sciences",
   "parent": "Science"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "22.2",
   "name": "Chemistry",
   "parent": "Science"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "22.3",
   "name": "Environment",
   "parent": "Science"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "22.4",
   "name": "Genetics",
   "parent": "Science"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "22.5",
   "name": "Geography",
   "parent": "Science"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "22.6",
   "name": "Geology",
   "parent": "Science"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "22.7",
   "name": "Physics",
   "parent": "Science"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "22.8",
   "name": "Space and Astronomy",
   "parent": "Science"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "23.1",
   "name": "Couponing",
   "parent": "Shopping"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "23",
   "name": "Shopping"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24",
   "name": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.1",
   "name": "American Football",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.1",
   "name": "Boxing",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.11",
   "name": "Cheerleading",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.12",
   "name": "College Sports",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.13",
   "name": "Cricket",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.14",
   "name": "Cycling",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.15",
   "name": "Darts",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.16",
   "name": "Disabled Sports",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.17",
   "name": "Diving",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.18",
   "name": "Equine Sports",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.18.1",
   "name": "Horse Racing",
   "parent": "Equine Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.19",
   "name": "Extreme Sports",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.19.1",
   "name": "Canoeing and Kayaking",
   "parent": "Extreme Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.19.2",
   "name": "Climbing",
   "parent": "Extreme Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.19.3",
   "name": "Paintball",
   "parent": "Extreme Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.19.4",
   "name": "Scuba Diving",
   "parent": "Extreme Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.19.5",
   "name": "Skateboarding",
   "parent": "Extreme Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.19.6",
   "name": "Snowboarding",
   "parent": "Extreme Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.19.7",
   "name": "Surfing and Bodyboarding",
   "parent": "Extreme Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.19.8",
   "name": "Waterskiing and Wakeboarding",
   "parent": "Extreme Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.2",
   "name": "Australian Rules Football",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.2",
   "name": "Fantasy Sports",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.21",
   "name": "Field Hockey",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.22",
   "name": "Figure Skating",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.23",
   "name": "Fishing Sports",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.24",
   "name": "Golf",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.25",
   "name": "Gymnastics",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.26",
   "name": "Hunting and Shooting",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.27",
   "name": "Ice Hockey",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.28",
   "name": "Inline Skating",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.29",
   "name": "Lacrosse",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.3",
   "name": "Auto Racing",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.3.1",
   "name": "Motorcycle Sports",
   "parent": "Auto Racing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.3",
   "name": "Martial Arts",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.31",
   "name": "Olympic Sports",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.31.1",
   "name": "Summer Olympic Sports",
   "parent": "Olympic Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.31.2",
   "name": "Winter Olympic Sports",
   "parent": "Olympic Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.32",
   "name": "Poker and Professional Gambling",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.33",
   "name": "Rodeo",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.34",
   "name": "Rowing",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.35",
   "name": "Rugby",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.35.1",
   "name": "Rugby League",
   "parent": "Rugby"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.35.2",
   "name": "Rugby Union",
   "parent": "Rugby"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.36",
   "name": "Sailing",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.37",
   "name": "Skiing",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.38",
   "name": "Snooker/Pool/Billiards",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.39",
   "name": "Soccer",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.4",
   "name": "Badminton",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.4",
   "name": "Softball",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.41",
   "name": "Squash",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.42",
   "name": "Swimming",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.43",
   "name": "Table Tennis",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.44",
   "name": "Tennis",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.45",
   "name": "Track and Field",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.46",
   "name": "Volleyball",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.47",
   "name": "Walking",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.48",
   "name": "Water Polo",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.49",
   "name": "Weightlifting",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.5",
   "name": "Baseball",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.5",
   "name": "Wrestling",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.6",
   "name": "Basketball",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.7",
   "name": "Beach Volleyball",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.8",
   "name": "Bodybuilding",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "24.9",
   "name": "Bowling",
   "parent": "Sports"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25",
   "name": "Style & Fashion"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.1",
   "name": "Beauty",
   "parent": "Style & Fashion"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.1.1",
   "name": "Hair Care",
   "parent": "Beauty"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.1.2",
   "name": "Makeup and Accessories",
   "parent": "Beauty"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.1.3",
   "name": "Nail Care",
   "parent": "Beauty"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.1.4",
   "name": "Natural and Organic Beauty",
   "parent": "Beauty"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.1.5",
   "name": "Perfume and Fragrance",
   "parent": "Beauty"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.1.6",
   "name": "Skin Care",
   "parent": "Beauty"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.1",
   "name": "Women's Fashion",
   "parent": "Style & Fashion"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.10.1",
   "name": "Women's Accessories",
   "parent": "Women's Fashion"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.10.1.1",
   "name": "Women's Glasses",
   "parent": "Women's Accessories"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.10.1.2",
   "name": "Women's Handbags and Wallets",
   "parent": "Women's Accessories"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.10.1.3",
   "name": "Women's Hats and Scarves",
   "parent": "Women's Accessories"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.10.1.4",
   "name": "Women's Jewelry and Watches",
   "parent": "Women's Accessories"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.10.2",
   "name": "Women's Clothing",
   "parent": "Women's Fashion"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.10.2.1",
   "name": "Women's Business Wear",
   "parent": "Women's Clothing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.10.2.2",
   "name": "Women's Casual Wear",
   "parent": "Women's Clothing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.10.2.3",
   "name": "Women's Formal Wear",
   "parent": "Women's Clothing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.10.2.4",
   "name": "Women's Intimates and Sleepwear",
   "parent": "Women's Clothing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.10.2.5",
   "name": "Women's Outerwear",
   "parent": "Women's Clothing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.10.2.6",
   "name": "Women's Sportswear",
   "parent": "Women's Clothing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.10.3",
   "name": "Women's Shoes and Footwear",
   "parent": "Women's Fashion"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.2",
   "name": "Body Art",
   "parent": "Style & Fashion"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.3",
   "name": "Children's Clothing",
   "parent": "Style & Fashion"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.4",
   "name": "Designer Clothing",
   "parent": "Style & Fashion"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.5",
   "name": "Fashion Trends",
   "parent": "Style & Fashion"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.6",
   "name": "High Fashion",
   "parent": "Style & Fashion"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.7",
   "name": "Men's Fashion",
   "parent": "Style & Fashion"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.7.1",
   "name": "Men's Accessories",
   "parent": "Men's Fashion"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.7.1.1",
   "name": "Men's Jewelry and Watches",
   "parent": "Men's Accessories"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.7.2",
   "name": "Men's Clothing",
   "parent": "Men's Fashion"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.7.2.1",
   "name": "Men's Business Wear",
   "parent": "Men's Clothing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.7.2.2",
   "name": "Men's Casual Wear",
   "parent": "Men's Clothing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.7.2.3",
   "name": "Men's Formal Wear",
   "parent": "Men's Clothing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.7.2.4",
   "name": "Men's Outerwear",
   "parent": "Men's Clothing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.7.2.5",
   "name": "Men's Sportswear",
   "parent": "Men's Clothing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.7.2.6",
   "name": "Men's Underwear and Sleepwear",
   "parent": "Men's Clothing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.7.3",
   "name": "Men's Shoes and Footwear",
   "parent": "Men's Fashion"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.8",
   "name": "Personal Care",
   "parent": "Style & Fashion"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.8.1",
   "name": "Bath and Shower",
   "parent": "Personal Care"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.8.2",
   "name": "Deodorant and Antiperspirant",
   "parent": "Personal Care"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.8.3",
   "name": "Oral care",
   "parent": "Personal Care"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.8.4",
   "name": "Shaving",
   "parent": "Personal Care"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "25.9",
   "name": "Street Style",
   "parent": "Style & Fashion"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26",
   "name": "Technology & Computing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.1",
   "name": "Artificial Intelligence",
   "parent": "Technology & Computing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.2",
   "name": "Augmented Reality",
   "parent": "Technology & Computing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3",
   "name": "Computing",
   "parent": "Technology & Computing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.1",
   "name": "Computer Networking",
   "parent": "Computing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.2",
   "name": "Computer Peripherals",
   "parent": "Computing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.3",
   "name": "Computer Software and Applications",
   "parent": "Computing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.3.1",
   "name": "3-D Graphics",
   "parent": "Computer Software and Applications"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.3.10",
   "name": "Photo Editing Software",
   "parent": "Computer Software and Applications"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.3.11",
   "name": "Shareware and Freeware",
   "parent": "Computer Software and Applications"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.3.12",
   "name": "Video Software",
   "parent": "Computer Software and Applications"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.3.13",
   "name": "Web Conferencing",
   "parent": "Computer Software and Applications"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.3.2",
   "name": "Antivirus Software",
   "parent": "Computer Software and Applications"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.3.3",
   "name": "Browsers",
   "parent": "Computer Software and Applications"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.3.4",
   "name": "Computer Animation",
   "parent": "Computer Software and Applications"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.3.5",
   "name": "Databases",
   "parent": "Computer Software and Applications"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.3.6",
   "name": "Desktop Publishing",
   "parent": "Computer Software and Applications"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.3.7",
   "name": "Digital Audio",
   "parent": "Computer Software and Applications"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.3.8",
   "name": "Graphics Software",
   "parent": "Computer Software and Applications"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.3.9",
   "name": "Operating Systems",
   "parent": "Computer Software and Applications"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.4",
   "name": "Data Storage and Warehousing",
   "parent": "Computing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.5",
   "name": "Desktops",
   "parent": "Computing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.6",
   "name": "Information and Network Security",
   "parent": "Computing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.7",
   "name": "Internet",
   "parent": "Computing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.7.1",
   "name": "Cloud Computing",
   "parent": "Internet"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.7.10",
   "name": "Web Development",
   "parent": "Internet"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.7.11",
   "name": "Web Hosting",
   "parent": "Internet"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.7.2",
   "name": "Email",
   "parent": "Internet"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.7.3",
   "name": "Internet for Beginners",
   "parent": "Internet"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.7.4",
   "name": "Internet of Things",
   "parent": "Internet"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.7.5",
   "name": "IT and Internet Support",
   "parent": "Internet"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.7.6",
   "name": "Search",
   "parent": "Internet"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.7.7",
   "name": "Social Networking",
   "parent": "Internet"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.7.8",
   "name": "Web Conferencing",
   "parent": "Internet"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.7.9",
   "name": "Web Design and HTML",
   "parent": "Internet"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.8",
   "name": "Laptops",
   "parent": "Computing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.3.9",
   "name": "Programming Languages",
   "parent": "Computing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.4",
   "name": "Consumer Electronics",
   "parent": "Technology & Computing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.4.1",
   "name": "Cameras and Camcorders",
   "parent": "Consumer Electronics"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.4.2",
   "name": "Home Entertainment Systems",
   "parent": "Consumer Electronics"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.4.3",
   "name": "Smartphones",
   "parent": "Consumer Electronics"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.4.4",
   "name": "Tablets and E-readers",
   "parent": "Consumer Electronics"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.4.5",
   "name": "Wearable Technology",
   "parent": "Consumer Electronics"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.5",
   "name": "Robotics",
   "parent": "Technology & Computing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "26.6",
   "name": "Virtual Reality",
   "parent": "Technology & Computing"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "27",
   "name": "Television"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "27.1",
   "name": "Animation TV",
   "parent": "Television"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "27.1",
   "name": "Soap Opera TV",
   "parent": "Television"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "27.11",
   "name": "Special Interest TV",
   "parent": "Television"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "27.12",
   "name": "Sports TV",
   "parent": "Television"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "27.2",
   "name": "Children's TV",
   "parent": "Television"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "27.3",
   "name": "Comedy TV",
   "parent": "Television"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "27.4",
   "name": "Drama TV",
   "parent": "Television"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "27.5",
   "name": "Factual TV",
   "parent": "Television"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "27.6",
   "name": "Holiday TV",
   "parent": "Television"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "27.7",
   "name": "Music TV",
   "parent": "Television"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "27.8",
   "name": "Reality TV",
   "parent": "Television"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "27.9",
   "name": "Science Fiction TV",
   "parent": "Television"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "28",
   "name": "Travel"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "28.1",
   "name": "Travel Accessories",
   "parent": "Travel"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "28.2",
   "name": "Travel Locations",
   "parent": "Travel"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "28.2.1",
   "name": "Africa Travel",
   "parent": "Travel Locations"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "28.2.2",
   "name": "Asia Travel",
   "parent": "Travel Locations"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "28.2.3",
   "name": "Australia and Oceania Travel",
   "parent": "Travel Locations"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "28.2.4",
   "name": "Europe Travel",
   "parent": "Travel Locations"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "28.2.5",
   "name": "North America Travel",
   "parent": "Travel Locations"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "28.2.6",
   "name": "Polar Travel",
   "parent": "Travel Locations"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "28.2.7",
   "name": "South America Travel",
   "parent": "Travel Locations"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "28.3",
   "name": "Travel Preparation",
   "parent": "Travel"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "28.4",
   "name": "Travel Type",
   "parent": "Travel"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "28.4.1",
   "name": "Adventure Travel",
   "parent": "Travel Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "28.4.10",
   "name": "Family Travel",
   "parent": "Travel Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "28.4.11",
   "name": "Honeymoons and Getaways",
   "parent": "Travel Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "28.4.12",
   "name": "Hotels and Motels",
   "parent": "Travel Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "28.4.13",
   "name": "Rail Travel",
   "parent": "Travel Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "28.4.14",
   "name": "Road Trips",
   "parent": "Travel Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "28.4.15",
   "name": "Spas",
   "parent": "Travel Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "28.4.2",
   "name": "Air Travel",
   "parent": "Travel Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "28.4.3",
   "name": "Beach Travel",
   "parent": "Travel Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "28.4.4",
   "name": "Bed & Breakfasts",
   "parent": "Travel Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "28.4.5",
   "name": "Budget Travel",
   "parent": "Travel Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "28.4.6",
   "name": "Business Travel",
   "parent": "Travel Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "28.4.7",
   "name": "Camping",
   "parent": "Travel Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "28.4.8",
   "name": "Cruises",
   "parent": "Travel Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "28.4.9",
   "name": "Day Trips",
   "parent": "Travel Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "29",
   "name": "Video Gaming"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "29.1",
   "name": "Console Games",
   "parent": "Video Gaming"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "29.2",
   "name": "eSports",
   "parent": "Video Gaming"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "29.3",
   "name": "Mobile Games",
   "parent": "Video Gaming"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "29.4",
   "name": "PC Games",
   "parent": "Video Gaming"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "29.5",
   "name": "Video Game Genres",
   "parent": "Video Gaming"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "29.5.1",
   "name": "Action Video Games",
   "parent": "Video Game Genres"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "29.5.10",
   "name": "Role-Playing Video Games",
   "parent": "Video Game Genres"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "29.5.11",
   "name": "Simulation Video Games",
   "parent": "Video Game Genres"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "29.5.12",
   "name": "Sports Video Games",
   "parent": "Video Game Genres"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "29.5.13",
   "name": "Strategy Video Games",
   "parent": "Video Game Genres"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "29.5.2",
   "name": "Action-Adventure Video Games",
   "parent": "Video Game Genres"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "29.5.3",
   "name": "Adventure Video Games",
   "parent": "Video Game Genres"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "29.5.4",
   "name": "Casual Games",
   "parent": "Video Game Genres"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "29.5.5",
   "name": "Educational Video Games",
   "parent": "Video Game Genres"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "29.5.6",
   "name": "Exercise and Fitness Video Games",
   "parent": "Video Game Genres"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "29.5.7",
   "name": "MMOs",
   "parent": "Video Game Genres"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "29.5.8",
   "name": "Music and Party Video Games",
   "parent": "Video Game Genres"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "29.5.9",
   "name": "Puzzle Video Games",
   "parent": "Video Game Genres"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CC",
   "name": "Content Channel"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CC.1",
   "name": "Editorial/Professional",
   "parent": "Content Channel"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CC.2",
   "name": "Email",
   "parent": "Content Channel"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CC.3",
   "name": "Forum/Community",
   "parent": "Content Channel"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CC.4",
   "name": "Game",
   "parent": "Content Channel"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CC.5",
   "name": "Marketplace/eCommerce",
   "parent": "Content Channel"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CC.6",
   "name": "Search Engine/Listings",
   "parent": "Content Channel"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CC.7",
   "name": "Social",
   "parent": "Content Channel"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CC.8",
   "name": "Utility/Online Tool",
   "parent": "Content Channel"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CC.9",
   "name": "Voice Activated Channels",
   "parent": "Content Channel"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CT",
   "name": "Content Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CT.1",
   "name": "Academic/ResearchConent",
   "parent": "Content Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CT.2",
   "name": "Chat/IM/Comments",
   "parent": "Content Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CT.3",
   "name": "Educational Content",
   "parent": "Content Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CT.4",
   "name": "Entertainment Content",
   "parent": "Content Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CT.5",
   "name": "Feature",
   "parent": "Content Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CT.6",
   "name": "General Social",
   "parent": "Content Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CT.7",
   "name": "Instructional Content",
   "parent": "Content Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CT.8",
   "name": "Interactive Content",
   "parent": "Content Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CT.9",
   "name": "Listings/Classifieds/Product Listings/Search Results",
   "parent": "Content Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CT.10",
   "name": "News",
   "parent": "Content Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CT.11",
   "name": "Review",
   "parent": "Content Type"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CF",
   "name": "Content Media Format"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CF.1",
   "name": "Audio",
   "parent": "Content Media Format"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CF.2",
   "name": "Images/Galleries",
   "parent": "Content Media Format"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CF.3",
   "name": "Interactive",
   "parent": "Content Media Format"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CF.4",
   "name": "Mixed",
   "parent": "Content Media Format"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CF.5",
   "name": "Textual",
   "parent": "Content Media Format"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CF.6",
   "name": "Video",
   "parent": "Content Media Format"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CF.7",
   "name": "VR/AR",
   "parent": "Content Media Format"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL",
   "name": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.aa",
   "name": "Afar",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ab",
   "name": "Abkhaz",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ae",
   "name": "Avestan",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.af",
   "name": "Afrikaans",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ak",
   "name": "Akan",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.am",
   "name": "Amharic",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.an",
   "name": "Aragonese",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ar",
   "name": "Arabic",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.as",
   "name": "Assamese",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.av",
   "name": "Avaric",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ay",
   "name": "Aymara",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.az",
   "name": "Azerbaijani",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ba",
   "name": "Bashkir",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.be",
   "name": "Belarusian",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.bg",
   "name": "Bulgarian",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.bh",
   "name": "Bihari",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.bi",
   "name": "Bislama",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.bm",
   "name": "Bambara",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.bn",
   "name": "Bengali",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.bo",
   "name": "Tibetan",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.br",
   "name": "Breton",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.bs",
   "name": "Bosnian",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ca",
   "name": "Catalan",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ce",
   "name": "Chechen",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ch",
   "name": "Chamorro",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.co",
   "name": "Corsican",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.cr",
   "name": "Cree",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.cs",
   "name": "Czech",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.cu",
   "name": "Old Church Slavonic",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.cv",
   "name": "Chuvash",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.cy",
   "name": "Welsh",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.da",
   "name": "Danish",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.de",
   "name": "German",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.dv",
   "name": "Divehi",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.dz",
   "name": "Dzongkha",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ee",
   "name": "Ewe",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.el",
   "name": "Greek",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.en",
   "name": "English",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.eo",
   "name": "Esperanto",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.es",
   "name": "Spanish",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.et",
   "name": "Estonian",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.eu",
   "name": "Basque",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.fa",
   "name": "Farsi",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ff",
   "name": "Fula",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.fi",
   "name": "Finnish",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.fj",
   "name": "Fijian",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.fo",
   "name": "Faroese",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.fr",
   "name": "French",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.fy",
   "name": "Western Frisian",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ga",
   "name": "Irish",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.gd",
   "name": "Scottish Gaelic",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.gl",
   "name": "Galician",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.gn",
   "name": "Guarani",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.gu",
   "name": "Gujarati",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.gv",
   "name": "Manx",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ha",
   "name": "Hausa",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.he",
   "name": "Hebrew",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.hi",
   "name": "Hindi",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ho",
   "name": "Hiri Motu",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.hr",
   "name": "Croatian",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ht",
   "name": "Haitian",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.hu",
   "name": "Hungarian",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.hy",
   "name": "Armenian",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.hz",
   "name": "Herero",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ia",
   "name": "Interlingua",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.id",
   "name": "Indonesian",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ie",
   "name": "Interlingue",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ig",
   "name": "Igbo",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ii",
   "name": "Nuosu",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ik",
   "name": "Inupiaq",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.io",
   "name": "Ido",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.is",
   "name": "Icelandic",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.it",
   "name": "Italian",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.iu",
   "name": "Inuktitut",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ja",
   "name": "Japanese",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.jv",
   "name": "Javanese",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ka",
   "name": "Georgian",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.kg",
   "name": "Kongo",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ki",
   "name": "Kikuyu",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.kj",
   "name": "Kwanyama",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.kk",
   "name": "Kazakh",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.kl",
   "name": "Kalaallisut",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.km",
   "name": "Khmer",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.kn",
   "name": "Kannada",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ko",
   "name": "Korean",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.kr",
   "name": "Kanuri",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ks",
   "name": "Kashmiri",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ku",
   "name": "Kurdish",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.kv",
   "name": "Komi",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.kw",
   "name": "Cornish",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ky",
   "name": "Kyrgyz",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.la",
   "name": "Latin",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.lb",
   "name": "Luxembourgish",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.lg",
   "name": "Ganda",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.li",
   "name": "Limburgish",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ln",
   "name": "Lingala",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.lo",
   "name": "Lao",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.lt",
   "name": "Lithuanian",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.lu",
   "name": "Luba-Katanga",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.lv",
   "name": "Latvian",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.mg",
   "name": "Malagasy",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.mh",
   "name": "Marshallese",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.mi",
   "name": "Māori",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.mk",
   "name": "Macedonian",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ml",
   "name": "Malayalam",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.mn",
   "name": "Mongolian",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.mr",
   "name": "Marathi",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ms",
   "name": "Malay",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.mt",
   "name": "Maltese",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.my",
   "name": "Burmese",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.na",
   "name": "Nauruan",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.nb",
   "name": "Norwegian Bokmal",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.nd",
   "name": "Northern Ndebele",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ne",
   "name": "Nepali",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ng",
   "name": "Ndonga",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.nl",
   "name": "Dutch",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.nn",
   "name": "Norwegian Nynorsk",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.no",
   "name": "Norwegian",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.nr",
   "name": "Southern Ndebele",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.nv",
   "name": "Navajo",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ny",
   "name": "Chichewa",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.oc",
   "name": "Occitan",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.oj",
   "name": "Ojibwe",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.om",
   "name": "Oromo",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.or",
   "name": "Oriya",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.os",
   "name": "Ossetian",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.pa",
   "name": "Punjabi",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.pi",
   "name": "Pali",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.pl",
   "name": "Polish",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ps",
   "name": "Pashto",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.pt",
   "name": "Portuguese",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.qu",
   "name": "Quechua",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.rm",
   "name": "Romansh",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.rn",
   "name": "Kirundi",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ro",
   "name": "Romanian",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ru",
   "name": "Russian",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.rw",
   "name": "Kinyarwanda",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.sa",
   "name": "Sanskrit",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.sc",
   "name": "Sardinian",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.sd",
   "name": "Sindhi",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.se",
   "name": "Northern Sami",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.sg",
   "name": "Sango",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.si",
   "name": "Sinhala",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.sk",
   "name": "Slovak",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.sl",
   "name": "Slovene",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.sm",
   "name": "Samoan",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.sn",
   "name": "Shona",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.so",
   "name": "Somali",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.sq",
   "name": "Albanian",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.sr",
   "name": "Serbian",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ss",
   "name": "Swati",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.st",
   "name": "Southern Sotho",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.su",
   "name": "Sundanese",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.sv",
   "name": "Swedish",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.sw",
   "name": "Swahili",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ta",
   "name": "Tamil",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.te",
   "name": "Telugu",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.tg",
   "name": "Tajik",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.th",
   "name": "Thai",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ti",
   "name": "Tigrinya",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.tk",
   "name": "Turkmen",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.tl",
   "name": "Tagalog",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.tn",
   "name": "Tswana",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.to",
   "name": "Tonga",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.tr",
   "name": "Turkish",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ts",
   "name": "Tsonga",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.tt",
   "name": "Tatar",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.tw",
   "name": "Twi",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ty",
   "name": "Tahitian",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ug",
   "name": "Uyghur",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.uk",
   "name": "Ukrainian",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ur",
   "name": "Urdu",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.uz",
   "name": "Uzbek",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.ve",
   "name": "Venda",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.vi",
   "name": "Vietnamese",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.vo",
   "name": "Volapuk",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.wa",
   "name": "Walloon",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.wo",
   "name": "Wolof",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.xh",
   "name": "Xhosa",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.yi",
   "name": "Yiddish",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.yo",
   "name": "Yoruba",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.za",
   "name": "Zhuang",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.zh",
   "name": "Chinese",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CL.zu",
   "name": "Zulu",
   "parent": "Content Language"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CM",
   "name": "Content Source"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CM.1",
   "name": "Professionally Produced",
   "parent": "Content Source"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CM.2",
   "name": "User Generated",
   "parent": "Content Source"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CM.3",
   "name": "Aggregated/Curated",
   "parent": "Content Source"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG",
   "name": "Content Source Geo"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.co",
   "name": "Continent",
   "parent": "Content Source Geo"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.co.1",
   "name": "Asia",
   "parent": "Continent"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.co.2",
   "name": "Africa",
   "parent": "Continent"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.co.3",
   "name": "North America",
   "parent": "Continent"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.co.4",
   "name": "South America",
   "parent": "Continent"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.co.5",
   "name": "Antarctica",
   "parent": "Continent"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.co.6",
   "name": "Europe",
   "parent": "Continent"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.co.7",
   "name": "Antarctica",
   "parent": "Continent"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn",
   "name": "Country",
   "parent": "Content Source Geo"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.AFG",
   "name": "Afghanistan",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.ALA",
   "name": "Aland Islands",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.ALB",
   "name": "Albania",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.DZA",
   "name": "Algeria",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.ASM",
   "name": "American Samoa",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.AND",
   "name": "Andorra",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.AGO",
   "name": "Angola",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.AIA",
   "name": "Anguilla",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.ATA",
   "name": "Antarctica",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.ATG",
   "name": "Antigua and Barbuda",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.ARG",
   "name": "Argentina",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.ARM",
   "name": "Armenia",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.ABW",
   "name": "Aruba",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.AUS",
   "name": "Australia",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.AUT",
   "name": "Austria",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.AZE",
   "name": "Azerbaijan",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.BHR",
   "name": "Bahrain",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.BGD",
   "name": "Bangladesh",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.BRB",
   "name": "Barbados",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.BLR",
   "name": "Belarus",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.BEL",
   "name": "Belgium",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.BLZ",
   "name": "Belize",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.BEN",
   "name": "Benin",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.BMU",
   "name": "Bermuda",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.BTN",
   "name": "Bhutan",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.VEN",
   "name": "Bolivarian Republic of Venezuela",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.BOL",
   "name": "Bolivia",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.BES",
   "name": "Bonaire, Sint Eustatius and Saba",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.BIH",
   "name": "Bosnia and Herzegovina",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.BWA",
   "name": "Botswana",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.BVT",
   "name": "Bouvet Island",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.BRA",
   "name": "Brazil",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.VGB",
   "name": "British Virgin Islands",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.BRN",
   "name": "Brunei Darussalam",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.BGR",
   "name": "Bulgaria",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.BFA",
   "name": "Burkina Faso",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.BDI",
   "name": "Burundi",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.CPV",
   "name": "Cabo Verde",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.KHM",
   "name": "Cambodia",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.CMR",
   "name": "Cameroon",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.CAN",
   "name": "Canada",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.TCD",
   "name": "Chad",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.CHL",
   "name": "Chile",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.CHN",
   "name": "China",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.CXR",
   "name": "Christmas Island",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.COL",
   "name": "Colombia",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.CRI",
   "name": "Costa Rica",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.CRV",
   "name": "Cote d'Ivoire",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.HRV",
   "name": "Croatia",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.CUB",
   "name": "Cuba",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.CUW",
   "name": "Curaçao",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.CYP",
   "name": "Cyprus",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.CZE",
   "name": "Czechia",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.DNK",
   "name": "Denmark",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.DJI",
   "name": "Djibouti",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.DMA",
   "name": "Dominica",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.ECU",
   "name": "Ecuador",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.EGY",
   "name": "Egypt",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.SLV",
   "name": "El Salvador",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.GNQ",
   "name": "Equatorial Guinea",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.ERI",
   "name": "Eritrea",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.EST",
   "name": "Estonia",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.ETH",
   "name": "Ethiopia",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.FSM",
   "name": "Federated States of Micronesia",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.FJI",
   "name": "Fiji",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.FIN",
   "name": "Finland",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.FRA",
   "name": "France",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.GUF",
   "name": "French Guiana",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.PYF",
   "name": "French Polynesia",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.GAB",
   "name": "Gabon",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.GEO",
   "name": "Georgia",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.DEU",
   "name": "Germany",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.GHA",
   "name": "Ghana",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.GIB",
   "name": "Gibraltar",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.GRC",
   "name": "Greece",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.GRL",
   "name": "Greenland",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.GRD",
   "name": "Grenada",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.GLP",
   "name": "Guadeloupe",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.GUM",
   "name": "Guam",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.GTM",
   "name": "Guatemala",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.GGY",
   "name": "Guernsey",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.GIN",
   "name": "Guinea",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.GNB",
   "name": "Guinea-Bissau",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.GUY",
   "name": "Guyana",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.HTI",
   "name": "Haiti",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.HMD",
   "name": "Heard Island and McDonald Islands",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.HND",
   "name": "Honduras",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.HKG",
   "name": "Hong Kong",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.HUN",
   "name": "Hungary",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.ISL",
   "name": "Iceland",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.IND",
   "name": "India",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.IDN",
   "name": "Indonesia",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.IRQ",
   "name": "Iraq",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.IRL",
   "name": "Ireland",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.IRN",
   "name": "Islamic Republic of Iran",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.IMN",
   "name": "Isle of Man",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.ISR",
   "name": "Israel",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.ITA",
   "name": "Italy",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.JAM",
   "name": "Jamaica",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.JPN",
   "name": "Japan",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.JEY",
   "name": "Jersey",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.JOR",
   "name": "Jordan",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.KAZ",
   "name": "Kazakhstan",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.KEN",
   "name": "Kenya",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.KIR",
   "name": "Kiribati",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.KWT",
   "name": "Kuwait",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.KGZ",
   "name": "Kyrgyzstan",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.LVA",
   "name": "Latvia",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.LBN",
   "name": "Lebanon",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.LSO",
   "name": "Lesotho",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.LBR",
   "name": "Liberia",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.LBY",
   "name": "Libya",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.LIE",
   "name": "Liechtenstein",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.LTU",
   "name": "Lithuania",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.LUX",
   "name": "Luxembourg",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.MAC",
   "name": "Macao",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.MDG",
   "name": "Madagascar",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.MWI",
   "name": "Malawi",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.MYS",
   "name": "Malaysia",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.MDV",
   "name": "Maldives",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.MLI",
   "name": "Mali",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.MLT",
   "name": "Malta",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.MTQ",
   "name": "Martinique",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.MRT",
   "name": "Mauritania",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.MUS",
   "name": "Mauritius",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.MYT",
   "name": "Mayotte",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.MEX",
   "name": "Mexico",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.MCO",
   "name": "Monaco",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.MNG",
   "name": "Mongolia",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.MNE",
   "name": "Montenegro",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.MSR",
   "name": "Montserrat",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.MAR",
   "name": "Morocco",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.MOZ",
   "name": "Mozambique",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.MMR",
   "name": "Myanmar",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.NAM",
   "name": "Namibia",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.NRU",
   "name": "Nauru",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.NPL",
   "name": "Nepal",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.NCL",
   "name": "New Caledonia",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.NZL",
   "name": "New Zealand",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.NIC",
   "name": "Nicaragua",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.NGA",
   "name": "Nigeria",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.NIU",
   "name": "Niue",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.NFK",
   "name": "Norfolk Island",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.NOR",
   "name": "Norway",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.OMN",
   "name": "Oman",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.PAK",
   "name": "Pakistan",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.PLW",
   "name": "Palau",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.PAN",
   "name": "Panama",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.PNG",
   "name": "Papua New Guinea",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.PRY",
   "name": "Paraguay",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.PER",
   "name": "Peru",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.PCN",
   "name": "Pitcairn",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.POL",
   "name": "Poland",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.PRT",
   "name": "Portugal",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.PRI",
   "name": "Puerto Rico",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.QAT",
   "name": "Qatar",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.REU",
   "name": "Reunion",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.ROU",
   "name": "Romania",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.RWA",
   "name": "Rwanda",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.BLM",
   "name": "Saint Barthelemy",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.SHN",
   "name": "Saint Helena, Ascension and Tristan da Cunha",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.KNA",
   "name": "Saint Kitts and Nevis",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.LCA",
   "name": "Saint Lucia",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.MAF",
   "name": "Saint Martin",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.SPM",
   "name": "Saint Pierre and Miquelon",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.VCT",
   "name": "Saint Vincent and the Grenadines",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.WSM",
   "name": "Samoa",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.SMR",
   "name": "San Marino",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.STP",
   "name": "Sao Tome and Principe",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.SAU",
   "name": "Saudi Arabia",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.SEN",
   "name": "Senegal",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.SRB",
   "name": "Serbia",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.SYC",
   "name": "Seychelles",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.SLE",
   "name": "Sierra Leone",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.SGP",
   "name": "Singapore",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.SXM",
   "name": "Sint Maarten",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.SVK",
   "name": "Slovakia",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.SVN",
   "name": "Slovenia",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.SLB",
   "name": "Solomon Islands",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.SOM",
   "name": "Somalia",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.ZAF",
   "name": "South Africa",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.SGS",
   "name": "South Georgia and the South Sandwich Islands",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.SSD",
   "name": "South Sudan",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.ESP",
   "name": "Spain",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.LKA",
   "name": "Sri Lanka",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.PSE",
   "name": "State of Palestine",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.SUR",
   "name": "Suriname",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.SJM",
   "name": "Svalbard and Jan Mayen",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.SWZ",
   "name": "Swaziland",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.SWE",
   "name": "Sweden",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.CHE",
   "name": "Switzerland",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.SYR",
   "name": "Syrian Arab Republic",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.TWN",
   "name": "Taiwan (Province of China)",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.TJK",
   "name": "Tajikistan",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.THA",
   "name": "Thailand",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.BHS",
   "name": "The Bahamas",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.IOT",
   "name": "The British Indian Ocean Territory",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.CYM",
   "name": "The Cayman Islands",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.CAF",
   "name": "The Central African Republic",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.CCK",
   "name": "The Cocos Islands",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.COM",
   "name": "The Comoros",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.COG",
   "name": "The Congo",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.COK",
   "name": "The Cook Islands",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.PRK",
   "name": "The Democratic People's Republic of Korea",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.COD",
   "name": "the Democratic Republic of the Congo ",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.DOM",
   "name": "The Dominican Republic",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.FLK",
   "name": "The Falkland Islands",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.FRO",
   "name": "The Faroe Islands",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.MKD",
   "name": "The former Yugoslav Republic of Macedonia",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.ATF",
   "name": "The French Southern Territories",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.GMB",
   "name": "The Gambia",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.VAT",
   "name": "The Holy See",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.LAO",
   "name": "The Lao People's Democratic Republic",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.MHL",
   "name": "The Marshall Islands",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.NLD",
   "name": "The Netherlands",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.NER",
   "name": "The Niger",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.MNP",
   "name": "The Northern Mariana Islands",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.PHL",
   "name": "The Philippines",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.KOR",
   "name": "The Republic of Korea",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.MDA",
   "name": "The Republic of Moldova",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.RUS",
   "name": "The Russian Federation",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.SDN",
   "name": "The Sudan",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.TCA",
   "name": "The Turks and Caicos Islands",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.ARE",
   "name": "The United Arab Emirates",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.GBR",
   "name": "The United Kingdom of Great Britain and Northern Ireland",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.UMI",
   "name": "The United States Minor Outlying Islands",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.USA",
   "name": "The United States of America",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.TLS",
   "name": "Timor-Leste",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.TGO",
   "name": "Togo",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.TKL",
   "name": "Tokelau",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.TON",
   "name": "Tonga",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.TTO",
   "name": "Trinidad and Tobago",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.TUN",
   "name": "Tunisia",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.TUR",
   "name": "Turkey",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.TKM",
   "name": "Turkmenistan",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.TUV",
   "name": "Tuvalu",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.VIR",
   "name": "U.S. Virgin Islands",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.UGA",
   "name": "Uganda",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.UKR",
   "name": "Ukraine",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.TZA",
   "name": "United Republic of Tanzania",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.URY",
   "name": "Uruguay",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.UZB",
   "name": "Uzbekistan",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.VUT",
   "name": "Vanuatu",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.VNM",
   "name": "Vietnam",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.WLF",
   "name": "Wallis and Futuna",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.ESH",
   "name": "Western Sahara",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.YEM",
   "name": "Yemen",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.ZMB",
   "name": "Zambia",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cn.ZWE",
   "name": "Zimbabwe",
   "parent": "Country"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.rg",
   "name": "Region/State",
   "parent": "Content Source Geo"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.me",
   "name": "Metro",
   "parent": "Content Source Geo"
}, {
   "taxonomy": "iab tech lab content taxonomy",
   "taxonomy_id": "CG.cy",
   "name": "City",
   "parent": "Content Source Geo"
}];

export const IAB = [
   {
      "1":"Automotive"
   },
   {
      "1.1":{
         "Automotive":"Auto Body Styles"
      }
   },
   {
      "1.1.1":{
         "Automotive":{
            "Auto Body Styles":"Commercial Trucks"
         }
      }
   },
   {
      "1.1.10":{
         "Automotive":{
            "Auto Body Styles":"Sedan"
         }
      }
   },
   {
      "1.1.11":{
         "Automotive":{
            "Auto Body Styles":"Station Wagon"
         }
      }
   },
   {
      "1.1.12":{
         "Automotive":{
            "Auto Body Styles":"SUV"
         }
      }
   },
   {
      "1.1.13":{
         "Automotive":{
            "Auto Body Styles":"Van"
         }
      }
   },
   {
      "1.1.2":{
         "Automotive":{
            "Auto Body Styles":"Convertible"
         }
      }
   },
   {
      "1.1.3":{
         "Automotive":{
            "Auto Body Styles":"Coupe"
         }
      }
   },
   {
      "1.1.4":{
         "Automotive":{
            "Auto Body Styles":"Crossover"
         }
      }
   },
   {
      "1.1.5":{
         "Automotive":{
            "Auto Body Styles":"Hatchback"
         }
      }
   },
   {
      "1.1.6":{
         "Automotive":{
            "Auto Body Styles":"Microcar"
         }
      }
   },
   {
      "1.1.7":{
         "Automotive":{
            "Auto Body Styles":"Minivan"
         }
      }
   },
   {
      "1.1.8":{
         "Automotive":{
            "Auto Body Styles":"Off-Road Vehicles"
         }
      }
   },
   {
      "1.1.9":{
         "Automotive":{
            "Auto Body Styles":"Pickup Trucks"
         }
      }
   },
   {
      "1.1":{
         "Automotive":"Auto Type"
      }
   },
   {
      "1.10.1":{
         "Automotive":{
            "Auto Type":"Budget Cars"
         }
      }
   },
   {
      "1.10.2":{
         "Automotive":{
            "Auto Type":"Certified Pre-Owned Cars"
         }
      }
   },
   {
      "1.10.3":{
         "Automotive":{
            "Auto Type":"Classic Cars"
         }
      }
   },
   {
      "1.10.4":{
         "Automotive":{
            "Auto Type":"Concept Cars"
         }
      }
   },
   {
      "1.10.5":{
         "Automotive":{
            "Auto Type":"Driverless Cars"
         }
      }
   },
   {
      "1.10.6":{
         "Automotive":{
            "Auto Type":"Green Vehicles"
         }
      }
   },
   {
      "1.11":{
         "Automotive":"Car Culture"
      }
   },
   {
      "1.12":{
         "Automotive":"Dash Cam Videos"
      }
   },
   {
      "1.13":{
         "Automotive":"Motorcycles"
      }
   },
   {
      "1.14":{
         "Automotive":"Road-Side Assistance"
      }
   },
   {
      "1.15":{
         "Automotive":"Scooters"
      }
   },
   {
      "1.2":{
         "Automotive":"Auto Buying and Selling"
      }
   },
   {
      "1.3":{
         "Automotive":"Auto Insurance"
      }
   },
   {
      "1.4":{
         "Automotive":"Auto Parts"
      }
   },
   {
      "1.5":{
         "Automotive":"Auto Recalls"
      }
   },
   {
      "1.6":{
         "Automotive":"Auto Repair"
      }
   },
   {
      "1.7":{
         "Automotive":"Auto Safety"
      }
   },
   {
      "1.8":{
         "Automotive":"Auto Shows"
      }
   },
   {
      "1.9":{
         "Automotive":"Auto Technology"
      }
   },
   {
      "1.9.1":{
         "Automotive":{
            "Auto Technology":"Auto Infotainment Technologies"
         }
      }
   },
   {
      "1.9.2":{
         "Automotive":{
            "Auto Technology":"Auto Navigation Systems"
         }
      }
   },
   {
      "1.9.3":{
         "Automotive":{
            "Auto Technology":"Auto Safety Technologies"
         }
      }
   },
   {
      "2":"Books and Literature"
   },
   {
      "2.1":{
         "Books and Literature":"Art and Photography Books"
      }
   },
   {
      "2.2":{
         "Books and Literature":"Biographies"
      }
   },
   {
      "2.3":{
         "Books and Literature":"Children's Literature"
      }
   },
   {
      "2.4":{
         "Books and Literature":"Comics and Graphic Novels"
      }
   },
   {
      "2.5":{
         "Books and Literature":"Cookbooks"
      }
   },
   {
      "2.6":{
         "Books and Literature":"Fiction"
      }
   },
   {
      "2.7":{
         "Books and Literature":"Poetry"
      }
   },
   {
      "2.8":{
         "Books and Literature":"Travel Books"
      }
   },
   {
      "2.9":{
         "Books and Literature":"Young Adult Literature"
      }
   },
   {
      "3":"Business and Finance"
   },
   {
      "3.1":{
         "Business and Finance":"Business"
      }
   },
   {
      "3.1.1":{
         "Business and Finance":{
            "Business":"Business Accounting & Finance"
         }
      }
   },
   {
      "3.1.10":{
         "Business and Finance":{
            "Business":"Human Resources"
         }
      }
   },
   {
      "3.1.11":{
         "Business and Finance":{
            "Business":"Large Business"
         }
      }
   },
   {
      "3.1.12":{
         "Business and Finance":{
            "Business":"Logistics"
         }
      }
   },
   {
      "3.1.13":{
         "Business and Finance":{
            "Business":"Marketing and Advertising"
         }
      }
   },
   {
      "3.1.14":{
         "Business and Finance":{
            "Business":"Sales"
         }
      }
   },
   {
      "3.1.15":{
         "Business and Finance":{
            "Business":"Small and Medium-sized Business"
         }
      }
   },
   {
      "3.1.16":{
         "Business and Finance":{
            "Business":"Startups"
         }
      }
   },
   {
      "3.1.2":{
         "Business and Finance":{
            "Business":"Business Administration"
         }
      }
   },
   {
      "3.1.3":{
         "Business and Finance":{
            "Business":"Business Banking & Finance"
         }
      }
   },
   {
      "3.1.3.1":{
         "Business and Finance":{
            "Business":{
               "Business Banking & Finance":"Angel Investment"
            }
         }
      }
   },
   {
      "3.1.3.2":{
         "Business and Finance":{
            "Business":{
               "Business Banking & Finance":"Bankruptcy"
            }
         }
      }
   },
   {
      "3.1.3.3":{
         "Business and Finance":{
            "Business":{
               "Business Banking & Finance":"Business Loans"
            }
         }
      }
   },
   {
      "3.1.3.4":{
         "Business and Finance":{
            "Business":{
               "Business Banking & Finance":"Debt Factoring & Invoice Discounting"
            }
         }
      }
   },
   {
      "3.1.3.5":{
         "Business and Finance":{
            "Business":{
               "Business Banking & Finance":"Mergers and Acquisitions"
            }
         }
      }
   },
   {
      "3.1.3.6":{
         "Business and Finance":{
            "Business":{
               "Business Banking & Finance":"Private Equity"
            }
         }
      }
   },
   {
      "3.1.3.7":{
         "Business and Finance":{
            "Business":{
               "Business Banking & Finance":"Sale & Lease Back"
            }
         }
      }
   },
   {
      "3.1.3.8":{
         "Business and Finance":{
            "Business":{
               "Business Banking & Finance":"Venture Capital"
            }
         }
      }
   },
   {
      "3.1.4":{
         "Business and Finance":{
            "Business":"Business I.T."
         }
      }
   },
   {
      "3.1.5":{
         "Business and Finance":{
            "Business":"Business Operations"
         }
      }
   },
   {
      "3.1.6":{
         "Business and Finance":{
            "Business":"Consumer Issues"
         }
      }
   },
   {
      "3.1.6.1":{
         "Business and Finance":{
            "Business":{
               "Consumer Issues":"Recalls"
            }
         }
      }
   },
   {
      "3.1.7":{
         "Business and Finance":{
            "Business":"Executive Leadership & Management"
         }
      }
   },
   {
      "3.1.8":{
         "Business and Finance":{
            "Business":"Government Business"
         }
      }
   },
   {
      "3.1.9":{
         "Business and Finance":{
            "Business":"Green Solutions"
         }
      }
   },
   {
      "3.2":{
         "Business and Finance":"Economy"
      }
   },
   {
      "3.2.1":{
         "Business and Finance":{
            "Economy":"Commodities"
         }
      }
   },
   {
      "3.2.2":{
         "Business and Finance":{
            "Economy":"Currencies"
         }
      }
   },
   {
      "3.2.3":{
         "Business and Finance":{
            "Economy":"Financial Crisis"
         }
      }
   },
   {
      "3.2.4":{
         "Business and Finance":{
            "Economy":"Financial Reform"
         }
      }
   },
   {
      "3.2.5":{
         "Business and Finance":{
            "Economy":"Financial Regulation"
         }
      }
   },
   {
      "3.2.6":{
         "Business and Finance":{
            "Economy":"Gasoline Prices"
         }
      }
   },
   {
      "3.2.7":{
         "Business and Finance":{
            "Economy":"Housing Market"
         }
      }
   },
   {
      "3.2.8":{
         "Business and Finance":{
            "Economy":"Interest Rates"
         }
      }
   },
   {
      "3.2.9":{
         "Business and Finance":{
            "Economy":"Job Market"
         }
      }
   },
   {
      "3.3":{
         "Business and Finance":"Industries"
      }
   },
   {
      "3.3.1":{
         "Business and Finance":{
            "Industries":"Advertising Industry"
         }
      }
   },
   {
      "3.3.10":{
         "Business and Finance":{
            "Industries":"Education industry"
         }
      }
   },
   {
      "3.3.11":{
         "Business and Finance":{
            "Industries":"Entertainment Industry"
         }
      }
   },
   {
      "3.3.12":{
         "Business and Finance":{
            "Industries":"Environmental Services Industry"
         }
      }
   },
   {
      "3.3.13":{
         "Business and Finance":{
            "Industries":"Financial Industry"
         }
      }
   },
   {
      "3.3.14":{
         "Business and Finance":{
            "Industries":"Food Industry"
         }
      }
   },
   {
      "3.3.15":{
         "Business and Finance":{
            "Industries":"Healthcare Industry"
         }
      }
   },
   {
      "3.3.16":{
         "Business and Finance":{
            "Industries":"Hospitality Industry"
         }
      }
   },
   {
      "3.3.17":{
         "Business and Finance":{
            "Industries":"Information Services Industry"
         }
      }
   },
   {
      "3.3.18":{
         "Business and Finance":{
            "Industries":"Legal Services Industry"
         }
      }
   },
   {
      "3.3.19":{
         "Business and Finance":{
            "Industries":"Logistics and Transportation Industry"
         }
      }
   },
   {
      "3.3.2":{
         "Business and Finance":{
            "Industries":"Agriculture"
         }
      }
   },
   {
      "3.3.20":{
         "Business and Finance":{
            "Industries":"Management Consulting Industry"
         }
      }
   },
   {
      "3.3.21":{
         "Business and Finance":{
            "Industries":"Manufacturing Industry"
         }
      }
   },
   {
      "3.3.22":{
         "Business and Finance":{
            "Industries":"Mechanical and Industrial Engineering Industry"
         }
      }
   },
   {
      "3.3.23":{
         "Business and Finance":{
            "Industries":"Media Industry"
         }
      }
   },
   {
      "3.3.24":{
         "Business and Finance":{
            "Industries":"Metals Industry"
         }
      }
   },
   {
      "3.3.25":{
         "Business and Finance":{
            "Industries":"Non-Profit Organizations"
         }
      }
   },
   {
      "3.3.26":{
         "Business and Finance":{
            "Industries":"Pharmaceutical Industry"
         }
      }
   },
   {
      "3.3.27":{
         "Business and Finance":{
            "Industries":"Power and Energy Industry"
         }
      }
   },
   {
      "3.3.28":{
         "Business and Finance":{
            "Industries":"Publishing Industry"
         }
      }
   },
   {
      "3.3.29":{
         "Business and Finance":{
            "Industries":"Real Estate Industry"
         }
      }
   },
   {
      "3.3.3":{
         "Business and Finance":{
            "Industries":"Apparel Industry"
         }
      }
   },
   {
      "3.3.30":{
         "Business and Finance":{
            "Industries":"Retail Industry"
         }
      }
   },
   {
      "3.3.31":{
         "Business and Finance":{
            "Industries":"Technology Industry"
         }
      }
   },
   {
      "3.3.32":{
         "Business and Finance":{
            "Industries":"Telecommunications Industry"
         }
      }
   },
   {
      "3.3.4":{
         "Business and Finance":{
            "Industries":"Automotive Industry"
         }
      }
   },
   {
      "3.3.5":{
         "Business and Finance":{
            "Industries":"Aviation Industry"
         }
      }
   },
   {
      "3.3.6":{
         "Business and Finance":{
            "Industries":"Biotech and Biomedical Industry"
         }
      }
   },
   {
      "3.3.7":{
         "Business and Finance":{
            "Industries":"Civil Engineering Industry"
         }
      }
   },
   {
      "3.3.8":{
         "Business and Finance":{
            "Industries":"Construction Industry"
         }
      }
   },
   {
      "3.3.9":{
         "Business and Finance":{
            "Industries":"Defense Industry"
         }
      }
   },
   {
      "4":"Careers"
   },
   {
      "4.1":{
         "Careers":"Apprenticeships"
      }
   },
   {
      "4.2":{
         "Careers":"Career Advice"
      }
   },
   {
      "4.3":{
         "Careers":"Career Planning"
      }
   },
   {
      "4.4":{
         "Careers":"Job Search"
      }
   },
   {
      "4.4.1":{
         "Careers":{
            "Job Search":"Job Fairs"
         }
      }
   },
   {
      "4.4.2":{
         "Careers":{
            "Job Search":"Resume Writing and Advice"
         }
      }
   },
   {
      "4.5":{
         "Careers":"Telecommuting"
      }
   },
   {
      "4.6":{
         "Careers":"Vocational Training"
      }
   },
   {
      "5":"Education"
   },
   {
      "5.1":{
         "Education":"Adult Education"
      }
   },
   {
      "5.1":{
         "Education":"Private School"
      }
   },
   {
      "5.11":{
         "Education":"Secondary Education"
      }
   },
   {
      "5.12":{
         "Education":"Special Education"
      }
   },
   {
      "5.2":{
         "Education":"College Education"
      }
   },
   {
      "5.2.1":{
         "Education":{
            "College Education":"College Planning"
         }
      }
   },
   {
      "5.2.2":{
         "Education":{
            "College Education":"Postgraduate Education"
         }
      }
   },
   {
      "5.2.2.1":{
         "Education":{
            "College Education":{
               "Postgraduate Education":"Professional School"
            }
         }
      }
   },
   {
      "5.2.3":{
         "Education":{
            "College Education":"Undergraduate Education"
         }
      }
   },
   {
      "5.3":{
         "Education":"Early Childhood Education"
      }
   },
   {
      "5.4":{
         "Education":"Educational Assessment"
      }
   },
   {
      "5.4.1":{
         "Education":{
            "Educational Assessment":"Standardized Testing"
         }
      }
   },
   {
      "5.5":{
         "Education":"Homeschooling"
      }
   },
   {
      "5.6":{
         "Education":"Homework and Study"
      }
   },
   {
      "5.7":{
         "Education":"Language Learning"
      }
   },
   {
      "5.8":{
         "Education":"Online Education"
      }
   },
   {
      "5.9":{
         "Education":"Primary Education"
      }
   },
   {
      "6":"Events and Attractions"
   },
   {
      "6.1":{
         "Events and Attractions":"Amusement and Theme Parks"
      }
   },
   {
      "6.1":{
         "Events and Attractions":"Fashion Events"
      }
   },
   {
      "6.11":{
         "Events and Attractions":"Historic Site and Landmark Tours"
      }
   },
   {
      "6.12":{
         "Events and Attractions":"Malls & Shopping Centers"
      }
   },
   {
      "6.13":{
         "Events and Attractions":"Museums & Galleries"
      }
   },
   {
      "6.14":{
         "Events and Attractions":"Musicals"
      }
   },
   {
      "6.15":{
         "Events and Attractions":"National & Civic Holidays"
      }
   },
   {
      "6.16":{
         "Events and Attractions":"Nightclubs"
      }
   },
   {
      "6.17":{
         "Events and Attractions":"Outdoor Activities"
      }
   },
   {
      "6.18":{
         "Events and Attractions":"Parks & Nature"
      }
   },
   {
      "6.19":{
         "Events and Attractions":"Party Supplies and Decorations"
      }
   },
   {
      "6.2":{
         "Events and Attractions":"Awards Shows"
      }
   },
   {
      "6.2":{
         "Events and Attractions":"Personal Celebrations & Life Events"
      }
   },
   {
      "6.20.1":{
         "Events and Attractions":{
            "Personal Celebrations & Life Events":"Anniversary"
         }
      }
   },
   {
      "6.20.10":{
         "Events and Attractions":{
            "Personal Celebrations & Life Events":"Wedding"
         }
      }
   },
   {
      "6.20.2":{
         "Events and Attractions":{
            "Personal Celebrations & Life Events":"Baby Shower"
         }
      }
   },
   {
      "6.20.3":{
         "Events and Attractions":{
            "Personal Celebrations & Life Events":"Bachelor Party"
         }
      }
   },
   {
      "6.20.4":{
         "Events and Attractions":{
            "Personal Celebrations & Life Events":"Bachelorette Party"
         }
      }
   },
   {
      "6.20.5":{
         "Events and Attractions":{
            "Personal Celebrations & Life Events":"Birth"
         }
      }
   },
   {
      "6.20.6":{
         "Events and Attractions":{
            "Personal Celebrations & Life Events":"Birthday"
         }
      }
   },
   {
      "6.20.7":{
         "Events and Attractions":{
            "Personal Celebrations & Life Events":"Funeral"
         }
      }
   },
   {
      "6.20.8":{
         "Events and Attractions":{
            "Personal Celebrations & Life Events":"Graduation"
         }
      }
   },
   {
      "6.20.9":{
         "Events and Attractions":{
            "Personal Celebrations & Life Events":"Prom"
         }
      }
   },
   {
      "6.21":{
         "Events and Attractions":"Political Event"
      }
   },
   {
      "6.22":{
         "Events and Attractions":"Religious Events"
      }
   },
   {
      "6.23":{
         "Events and Attractions":"Sporting Events"
      }
   },
   {
      "6.24":{
         "Events and Attractions":"Theater Venues and Events"
      }
   },
   {
      "6.25":{
         "Events and Attractions":"Zoos & Aquariums"
      }
   },
   {
      "6.3":{
         "Events and Attractions":"Bars & Restaurants"
      }
   },
   {
      "6.4":{
         "Events and Attractions":"Business Expos & Conferences"
      }
   },
   {
      "6.5":{
         "Events and Attractions":"Casinos & Gambling"
      }
   },
   {
      "6.6":{
         "Events and Attractions":"Cinemas and Events"
      }
   },
   {
      "6.7":{
         "Events and Attractions":"Comedy Events"
      }
   },
   {
      "6.8":{
         "Events and Attractions":"Concerts & Music Events"
      }
   },
   {
      "6.9":{
         "Events and Attractions":"Fan Conventions"
      }
   },
   {
      "7":"Family and Relationships"
   },
   {
      "7.1":{
         "Family and Relationships":"Bereavement"
      }
   },
   {
      "7.2":{
         "Family and Relationships":"Dating"
      }
   },
   {
      "7.3":{
         "Family and Relationships":"Divorce"
      }
   },
   {
      "7.4":{
         "Family and Relationships":"Eldercare"
      }
   },
   {
      "7.5":{
         "Family and Relationships":"Marriage and Civil Unions"
      }
   },
   {
      "7.6":{
         "Family and Relationships":"Parenting"
      }
   },
   {
      "7.6.1":{
         "Family and Relationships":{
            "Parenting":"Adoption and Fostering"
         }
      }
   },
   {
      "7.6.2":{
         "Family and Relationships":{
            "Parenting":"Daycare and Pre-School"
         }
      }
   },
   {
      "7.6.3":{
         "Family and Relationships":{
            "Parenting":"Internet Safety"
         }
      }
   },
   {
      "7.6.4":{
         "Family and Relationships":{
            "Parenting":"Parenting Babies and Toddlers"
         }
      }
   },
   {
      "7.6.5":{
         "Family and Relationships":{
            "Parenting":"Parenting Children Aged 4-11"
         }
      }
   },
   {
      "7.6.6":{
         "Family and Relationships":{
            "Parenting":"Parenting Teens"
         }
      }
   },
   {
      "7.6.7":{
         "Family and Relationships":{
            "Parenting":"Pregnancy"
         }
      }
   },
   {
      "7.6.8":{
         "Family and Relationships":{
            "Parenting":"Special Needs Kids"
         }
      }
   },
   {
      "7.7":{
         "Family and Relationships":"Single Life"
      }
   },
   {
      "8":"Fine Art"
   },
   {
      "8.1":{
         "Fine Art":"Costume"
      }
   },
   {
      "8.2":{
         "Fine Art":"Dance"
      }
   },
   {
      "8.3":{
         "Fine Art":"Design"
      }
   },
   {
      "8.4":{
         "Fine Art":"Digital Arts"
      }
   },
   {
      "8.5":{
         "Fine Art":"Fine Art Photography"
      }
   },
   {
      "8.6":{
         "Fine Art":"Fine Art Photography"
      }
   },
   {
      "8.7":{
         "Fine Art":"Modern Art"
      }
   },
   {
      "8.8":{
         "Fine Art":"Opera"
      }
   },
   {
      "8.9":{
         "Fine Art":"Theater"
      }
   },
   {
      "9":"Food & Drink"
   },
   {
      "9.1":{
         "Food & Drink":"Alcoholic Beverages"
      }
   },
   {
      "9.1":{
         "Food & Drink":"Vegan Diets"
      }
   },
   {
      "9.11":{
         "Food & Drink":"Vegetarian Diets"
      }
   },
   {
      "9.12":{
         "Food & Drink":"World Cuisines"
      }
   },
   {
      "9.2":{
         "Food & Drink":"Barbecues and Grilling"
      }
   },
   {
      "9.3":{
         "Food & Drink":"Cooking"
      }
   },
   {
      "9.4":{
         "Food & Drink":"Desserts and Baking"
      }
   },
   {
      "9.5":{
         "Food & Drink":"Dining Out"
      }
   },
   {
      "9.6":{
         "Food & Drink":"Food Allergies"
      }
   },
   {
      "9.7":{
         "Food & Drink":"Food Movements"
      }
   },
   {
      "9.8":{
         "Food & Drink":"Healthy Cooking and Eating"
      }
   },
   {
      "9.9":{
         "Food & Drink":"Non-Alcoholic Beverages"
      }
   },
   {
      "10":"Healthy Living"
   },
   {
      "10.1":{
         "Healthy Living":"Children's Health"
      }
   },
   {
      "10.2":{
         "Healthy Living":"Fitness and Exercise"
      }
   },
   {
      "10.2.1":{
         "Healthy Living":{
            "Fitness and Exercise":"Participant Sports"
         }
      }
   },
   {
      "10.2.2":{
         "Healthy Living":{
            "Fitness and Exercise":"Running and Jogging"
         }
      }
   },
   {
      "10.3":{
         "Healthy Living":"Men's Health"
      }
   },
   {
      "10.4":{
         "Healthy Living":"Nutrition"
      }
   },
   {
      "10.5":{
         "Healthy Living":"Senior Health"
      }
   },
   {
      "10.6":{
         "Healthy Living":"Weight Loss"
      }
   },
   {
      "10.7":{
         "Healthy Living":"Wellness"
      }
   },
   {
      "10.7.1":{
         "Healthy Living":{
            "Wellness":"Alternative Medicine"
         }
      }
   },
   {
      "10.7.2":{
         "Healthy Living":{
            "Wellness":"Physical Therapy"
         }
      }
   },
   {
      "10.7.3":{
         "Healthy Living":{
            "Wellness":"Smoking Cessation"
         }
      }
   },
   {
      "10.8":{
         "Healthy Living":"Women's Health"
      }
   },
   {
      "11":"Hobbies & Interests"
   },
   {
      "11.1":{
         "Hobbies & Interests":"Antiquing and Antiques"
      }
   },
   {
      "11.1":{
         "Hobbies & Interests":"Magic and Illusion"
      }
   },
   {
      "11.11":{
         "Hobbies & Interests":"Model Toys"
      }
   },
   {
      "11.12":{
         "Hobbies & Interests":"Musical Instruments"
      }
   },
   {
      "11.13":{
         "Hobbies & Interests":"Paranormal Phenomena"
      }
   },
   {
      "11.14":{
         "Hobbies & Interests":"Radio Control"
      }
   },
   {
      "11.15":{
         "Hobbies & Interests":"Sci-fi and Fantasy"
      }
   },
   {
      "11.16":{
         "Hobbies & Interests":"Workshops and Classes"
      }
   },
   {
      "11.2":{
         "Hobbies & Interests":"Arts and Crafts"
      }
   },
   {
      "11.2.1":{
         "Hobbies & Interests":{
            "Arts and Crafts":"Beadwork"
         }
      }
   },
   {
      "11.2.2":{
         "Hobbies & Interests":{
            "Arts and Crafts":"Candle and Soap Making"
         }
      }
   },
   {
      "11.2.3":{
         "Hobbies & Interests":{
            "Arts and Crafts":"Drawing and Sketching"
         }
      }
   },
   {
      "11.2.4":{
         "Hobbies & Interests":{
            "Arts and Crafts":"Jewelry Making"
         }
      }
   },
   {
      "11.2.5":{
         "Hobbies & Interests":{
            "Arts and Crafts":"Needlework"
         }
      }
   },
   {
      "11.2.6":{
         "Hobbies & Interests":{
            "Arts and Crafts":"Painting"
         }
      }
   },
   {
      "11.2.7":{
         "Hobbies & Interests":{
            "Arts and Crafts":"Photography"
         }
      }
   },
   {
      "11.2.8":{
         "Hobbies & Interests":{
            "Arts and Crafts":"Scrapbooking"
         }
      }
   },
   {
      "11.2.9":{
         "Hobbies & Interests":{
            "Arts and Crafts":"Woodworking"
         }
      }
   },
   {
      "11.3":{
         "Hobbies & Interests":"Beekeeping"
      }
   },
   {
      "11.4":{
         "Hobbies & Interests":"Birdwatching"
      }
   },
   {
      "11.5":{
         "Hobbies & Interests":"Cigars"
      }
   },
   {
      "11.6":{
         "Hobbies & Interests":"Collecting"
      }
   },
   {
      "11.6.1":{
         "Hobbies & Interests":{
            "Collecting":"Comic Books"
         }
      }
   },
   {
      "11.6.2":{
         "Hobbies & Interests":{
            "Collecting":"Stamps and Coins"
         }
      }
   },
   {
      "11.7":{
         "Hobbies & Interests":"Content Production"
      }
   },
   {
      "11.7.1":{
         "Hobbies & Interests":{
            "Content Production":"Audio Production"
         }
      }
   },
   {
      "11.7.2":{
         "Hobbies & Interests":{
            "Content Production":"Freelance Writing"
         }
      }
   },
   {
      "11.7.3":{
         "Hobbies & Interests":{
            "Content Production":"Screenwriting"
         }
      }
   },
   {
      "11.7.4":{
         "Hobbies & Interests":{
            "Content Production":"Video Production"
         }
      }
   },
   {
      "11.8":{
         "Hobbies & Interests":"Games and Puzzles"
      }
   },
   {
      "11.8.1":{
         "Hobbies & Interests":{
            "Games and Puzzles":"Board Games and Puzzles"
         }
      }
   },
   {
      "11.8.2":{
         "Hobbies & Interests":{
            "Games and Puzzles":"Card Games"
         }
      }
   },
   {
      "11.8.3":{
         "Hobbies & Interests":{
            "Games and Puzzles":"Roleplaying Games"
         }
      }
   },
   {
      "11.9":{
         "Hobbies & Interests":"Genealogy and Ancestry"
      }
   },
   {
      "12":"Home & Garden"
   },
   {
      "12.1":{
         "Home & Garden":"Gardening"
      }
   },
   {
      "12.1":{
         "Home & Garden":"Remodeling & Construction"
      }
   },
   {
      "12.11":{
         "Home & Garden":"Smart Home"
      }
   },
   {
      "12.2":{
         "Home & Garden":"Home Appliances"
      }
   },
   {
      "12.3":{
         "Home & Garden":"Home Entertaining"
      }
   },
   {
      "12.4":{
         "Home & Garden":"Home Improvement"
      }
   },
   {
      "12.5":{
         "Home & Garden":"Home Security"
      }
   },
   {
      "12.6":{
         "Home & Garden":"Indoor Environmental Quality"
      }
   },
   {
      "12.7":{
         "Home & Garden":"Interior Decorating"
      }
   },
   {
      "12.8":{
         "Home & Garden":"Landscaping"
      }
   },
   {
      "12.9":{
         "Home & Garden":"Outdoor Decorating"
      }
   },
   {
      "13":"Medical Health"
   },
   {
      "13.1":{
         "Medical Health":"Diseases and Conditions"
      }
   },
   {
      "13.1.1":{
         "Medical Health":{
            "Diseases and Conditions":"Allergies"
         }
      }
   },
   {
      "13.1.10":{
         "Medical Health":{
            "Diseases and Conditions":"Ear, Nose and Throat Conditions"
         }
      }
   },
   {
      "13.1.11":{
         "Medical Health":{
            "Diseases and Conditions":"Endocrine and Metabolic Diseases"
         }
      }
   },
   {
      "13.1.11.1":{
         "Medical Health":{
            "Diseases and Conditions":{
               "Endocrine and Metabolic Diseases":"Hormonal Disorders"
            }
         }
      }
   },
   {
      "13.1.11.2":{
         "Medical Health":{
            "Diseases and Conditions":{
               "Endocrine and Metabolic Diseases":"Menopause"
            }
         }
      }
   },
   {
      "13.1.11.3":{
         "Medical Health":{
            "Diseases and Conditions":{
               "Endocrine and Metabolic Diseases":"Thyroid Disorders"
            }
         }
      }
   },
   {
      "13.1.12":{
         "Medical Health":{
            "Diseases and Conditions":"Eye and Vision Conditions"
         }
      }
   },
   {
      "13.1.13":{
         "Medical Health":{
            "Diseases and Conditions":"Foot Health"
         }
      }
   },
   {
      "13.1.14":{
         "Medical Health":{
            "Diseases and Conditions":"Heart and Cardiovascular Diseases"
         }
      }
   },
   {
      "13.1.15":{
         "Medical Health":{
            "Diseases and Conditions":"Infectious Diseases"
         }
      }
   },
   {
      "13.1.16":{
         "Medical Health":{
            "Diseases and Conditions":"Injuries"
         }
      }
   },
   {
      "13.1.16.1":{
         "Medical Health":{
            "Diseases and Conditions":{
               "Injuries":"First Aid"
            }
         }
      }
   },
   {
      "13.1.17":{
         "Medical Health":{
            "Diseases and Conditions":"Lung and Respiratory Health"
         }
      }
   },
   {
      "13.1.18":{
         "Medical Health":{
            "Diseases and Conditions":"Mental Health"
         }
      }
   },
   {
      "13.1.19":{
         "Medical Health":{
            "Diseases and Conditions":"Reproductive Health"
         }
      }
   },
   {
      "13.1.19.1":{
         "Medical Health":{
            "Diseases and Conditions":{
               "Reproductive Health":"Birth Control"
            }
         }
      }
   },
   {
      "13.1.19.2":{
         "Medical Health":{
            "Diseases and Conditions":{
               "Reproductive Health":"Infertility"
            }
         }
      }
   },
   {
      "13.1.19.3":{
         "Medical Health":{
            "Diseases and Conditions":{
               "Reproductive Health":"Pregnancy"
            }
         }
      }
   },
   {
      "13.1.2":{
         "Medical Health":{
            "Diseases and Conditions":"Blood Disorders"
         }
      }
   },
   {
      "13.1.20":{
         "Medical Health":{
            "Diseases and Conditions":"Sexual Health"
         }
      }
   },
   {
      "13.1.20.1":{
         "Medical Health":{
            "Diseases and Conditions":{
               "Sexual Health":"Sexual Conditions"
            }
         }
      }
   },
   {
      "13.1.21":{
         "Medical Health":{
            "Diseases and Conditions":"Skin and Dermatology"
         }
      }
   },
   {
      "13.1.22":{
         "Medical Health":{
            "Diseases and Conditions":"Sleep Disorders"
         }
      }
   },
   {
      "13.1.23":{
         "Medical Health":{
            "Diseases and Conditions":"Substance Abuse"
         }
      }
   },
   {
      "13.1.3":{
         "Medical Health":{
            "Diseases and Conditions":"Bone and Joint Conditions"
         }
      }
   },
   {
      "13.1.4":{
         "Medical Health":{
            "Diseases and Conditions":"Brain and Nervous System Disorders"
         }
      }
   },
   {
      "13.1.5":{
         "Medical Health":{
            "Diseases and Conditions":"Cancer"
         }
      }
   },
   {
      "13.1.6":{
         "Medical Health":{
            "Diseases and Conditions":"Cold and Flu"
         }
      }
   },
   {
      "13.1.7":{
         "Medical Health":{
            "Diseases and Conditions":"Dental Health"
         }
      }
   },
   {
      "13.1.8":{
         "Medical Health":{
            "Diseases and Conditions":"Diabetes"
         }
      }
   },
   {
      "13.1.9":{
         "Medical Health":{
            "Diseases and Conditions":"Digestive Disorders"
         }
      }
   },
   {
      "13.2":{
         "Medical Health":"Medical Tests"
      }
   },
   {
      "13.3":{
         "Medical Health":"Pharmaceutical Drugs"
      }
   },
   {
      "13.4":{
         "Medical Health":"Surgery"
      }
   },
   {
      "13.5":{
         "Medical Health":"Vaccines"
      }
   },
   {
      "14":"Movies"
   },
   {
      "14.1":{
         "Movies":"Action and Adventure Movies"
      }
   },
   {
      "14.1":{
         "Movies":"Romance Movies"
      }
   },
   {
      "14.11":{
         "Movies":"Science Fiction Movies"
      }
   },
   {
      "14.12":{
         "Movies":"Special Interest Movies"
      }
   },
   {
      "14.2":{
         "Movies":"Animation Movies"
      }
   },
   {
      "14.3":{
         "Movies":"Comedy Movies"
      }
   },
   {
      "14.4":{
         "Movies":"Crime and Mystery Movies"
      }
   },
   {
      "14.5":{
         "Movies":"Documentary Movies"
      }
   },
   {
      "14.6":{
         "Movies":"Drama Movies"
      }
   },
   {
      "14.7":{
         "Movies":"Family and Children Movies"
      }
   },
   {
      "14.8":{
         "Movies":"Fantasy Movies"
      }
   },
   {
      "14.9":{
         "Movies":"Horror Movies"
      }
   },
   {
      "15":"Music and Audio"
   },
   {
      "15.1":{
         "Music and Audio":"Adult Contemporary Music"
      }
   },
   {
      "15.1":{
         "Music and Audio":"Comedy Podcasts"
      }
   },
   {
      "15.11":{
         "Music and Audio":"Comedy Radio"
      }
   },
   {
      "15.12":{
         "Music and Audio":"Contemporary Hits"
      }
   },
   {
      "15.13":{
         "Music and Audio":"Country Music"
      }
   },
   {
      "15.14":{
         "Music and Audio":"Dance and Electronic Music"
      }
   },
   {
      "15.15":{
         "Music and Audio":"Education Podcasts"
      }
   },
   {
      "15.16":{
         "Music and Audio":"Folk Music"
      }
   },
   {
      "15.17":{
         "Music and Audio":"Games & Hobbies Podcasts"
      }
   },
   {
      "15.18":{
         "Music and Audio":"Gospel Music"
      }
   },
   {
      "15.19":{
         "Music and Audio":"Health Podcasts"
      }
   },
   {
      "15.2":{
         "Music and Audio":"Arts Podcasts"
      }
   },
   {
      "15.2":{
         "Music and Audio":"Hip Hop Music"
      }
   },
   {
      "15.21":{
         "Music and Audio":"Inspirational Music"
      }
   },
   {
      "15.22":{
         "Music and Audio":"International Music"
      }
   },
   {
      "15.23":{
         "Music and Audio":"Jazz"
      }
   },
   {
      "15.24":{
         "Music and Audio":"Kids & Family Podcasts"
      }
   },
   {
      "15.25":{
         "Music and Audio":"News & Politics Podcasts"
      }
   },
   {
      "15.26":{
         "Music and Audio":"Oldies Music"
      }
   },
   {
      "15.27":{
         "Music and Audio":"Public Radio"
      }
   },
   {
      "15.28":{
         "Music and Audio":"Reggae"
      }
   },
   {
      "15.29":{
         "Music and Audio":"Religion & Spirituality Podcasts"
      }
   },
   {
      "15.3":{
         "Music and Audio":"Blues"
      }
   },
   {
      "15.3":{
         "Music and Audio":"Religious Music"
      }
   },
   {
      "15.31":{
         "Music and Audio":"Rhythm and Blues"
      }
   },
   {
      "15.32":{
         "Music and Audio":"Rock Music"
      }
   },
   {
      "15.32.1":{
         "Music and Audio":{
            "Rock Music":"Album-oriented Rock"
         }
      }
   },
   {
      "15.32.2":{
         "Music and Audio":{
            "Rock Music":"Alternative Rock"
         }
      }
   },
   {
      "15.32.3":{
         "Music and Audio":{
            "Rock Music":"Classic Rock"
         }
      }
   },
   {
      "15.32.4":{
         "Music and Audio":{
            "Rock Music":"Hard Rock"
         }
      }
   },
   {
      "15.33":{
         "Music and Audio":"Science & Medicine Podcasts"
      }
   },
   {
      "15.34":{
         "Music and Audio":"Society & Culture Podcasts"
      }
   },
   {
      "15.35":{
         "Music and Audio":"Soundtracks"
      }
   },
   {
      "15.36":{
         "Music and Audio":"Sports & Recreation Podcasts"
      }
   },
   {
      "15.37":{
         "Music and Audio":"Sports Play-by-Play"
      }
   },
   {
      "15.38":{
         "Music and Audio":"Sports Talk Radio"
      }
   },
   {
      "15.39":{
         "Music and Audio":"Talk Radio"
      }
   },
   {
      "15.39.1":{
         "Music and Audio":{
            "Talk Radio":"All-news radio"
         }
      }
   },
   {
      "15.39.2":{
         "Music and Audio":{
            "Talk Radio":"Educational Radio"
         }
      }
   },
   {
      "15.39.3":{
         "Music and Audio":{
            "Talk Radio":"News/Talk"
         }
      }
   },
   {
      "15.4":{
         "Music and Audio":"Business News Radio"
      }
   },
   {
      "15.4":{
         "Music and Audio":"Technology Podcasts"
      }
   },
   {
      "15.41":{
         "Music and Audio":"TV & Film Podcasts"
      }
   },
   {
      "15.42":{
         "Music and Audio":"Urban Adult Contemporary Music"
      }
   },
   {
      "15.43":{
         "Music and Audio":"Urban Contemporary Music"
      }
   },
   {
      "15.5":{
         "Music and Audio":"Business Podcasts"
      }
   },
   {
      "15.6":{
         "Music and Audio":"Children's Music"
      }
   },
   {
      "15.7":{
         "Music and Audio":"Classic Hits"
      }
   },
   {
      "15.8":{
         "Music and Audio":"Classical Music"
      }
   },
   {
      "15.9":{
         "Music and Audio":"College Radio"
      }
   },
   {
      "16":"News and Politics"
   },
   {
      "16.1":{
         "News and Politics":"Crime"
      }
   },
   {
      "16.2":{
         "News and Politics":"Disasters"
      }
   },
   {
      "16.3":{
         "News and Politics":"International News"
      }
   },
   {
      "16.4":{
         "News and Politics":"Law"
      }
   },
   {
      "16.5":{
         "News and Politics":"Local News"
      }
   },
   {
      "16.6":{
         "News and Politics":"National News"
      }
   },
   {
      "16.7":{
         "News and Politics":"Politics"
      }
   },
   {
      "16.7.1":{
         "News and Politics":{
            "Politics":"Elections"
         }
      }
   },
   {
      "16.7.2":{
         "News and Politics":{
            "Politics":"Political Issues"
         }
      }
   },
   {
      "16.7.3":{
         "News and Politics":{
            "Politics":"War and Conflicts"
         }
      }
   },
   {
      "16.8":{
         "News and Politics":"Weather"
      }
   },
   {
      "17":"Personal Finance"
   },
   {
      "17.1":{
         "Personal Finance":"Consumer Banking"
      }
   },
   {
      "17.2":{
         "Personal Finance":"Financial Assistance"
      }
   },
   {
      "17.2.1":{
         "Personal Finance":{
            "Financial Assistance":"Government Support and Welfare"
         }
      }
   },
   {
      "17.2.2":{
         "Personal Finance":{
            "Financial Assistance":"Student Financial Aid"
         }
      }
   },
   {
      "17.3":{
         "Personal Finance":"Financial Planning"
      }
   },
   {
      "17.4":{
         "Personal Finance":"Frugal Living"
      }
   },
   {
      "17.5":{
         "Personal Finance":"Insurance"
      }
   },
   {
      "17.5.1":{
         "Personal Finance":{
            "Insurance":"Health Insurance"
         }
      }
   },
   {
      "17.5.2":{
         "Personal Finance":{
            "Insurance":"Home Insurance"
         }
      }
   },
   {
      "17.5.3":{
         "Personal Finance":{
            "Insurance":"Life Insurance"
         }
      }
   },
   {
      "17.5.4":{
         "Personal Finance":{
            "Insurance":"Motor Insurance"
         }
      }
   },
   {
      "17.5.5":{
         "Personal Finance":{
            "Insurance":"Pet Insurance"
         }
      }
   },
   {
      "17.5.6":{
         "Personal Finance":{
            "Insurance":"Travel Insurance"
         }
      }
   },
   {
      "17.6":{
         "Personal Finance":"Personal Debt"
      }
   },
   {
      "17.6.1":{
         "Personal Finance":{
            "Personal Debt":"Credit Cards"
         }
      }
   },
   {
      "17.6.2":{
         "Personal Finance":{
            "Personal Debt":"Home Financing"
         }
      }
   },
   {
      "17.6.3":{
         "Personal Finance":{
            "Personal Debt":"Personal Loans"
         }
      }
   },
   {
      "17.6.4":{
         "Personal Finance":{
            "Personal Debt":"Student Loans"
         }
      }
   },
   {
      "17.7":{
         "Personal Finance":"Personal Investing"
      }
   },
   {
      "17.7.1":{
         "Personal Finance":{
            "Personal Investing":"Hedge Funds"
         }
      }
   },
   {
      "17.7.2":{
         "Personal Finance":{
            "Personal Investing":"Mutual Funds"
         }
      }
   },
   {
      "17.7.3":{
         "Personal Finance":{
            "Personal Investing":"Options"
         }
      }
   },
   {
      "17.7.4":{
         "Personal Finance":{
            "Personal Investing":"Stocks and Bonds"
         }
      }
   },
   {
      "17.8":{
         "Personal Finance":"Personal Taxes"
      }
   },
   {
      "17.9":{
         "Personal Finance":"Retirement Planning"
      }
   },
   {
      "18":"Pets"
   },
   {
      "18.1":{
         "Pets":"Birds"
      }
   },
   {
      "18.2":{
         "Pets":"Cats"
      }
   },
   {
      "18.3":{
         "Pets":"Dogs"
      }
   },
   {
      "18.4":{
         "Pets":"Fish and Aquariums"
      }
   },
   {
      "18.5":{
         "Pets":"Large Animals"
      }
   },
   {
      "18.6":{
         "Pets":"Pet Adoptions"
      }
   },
   {
      "18.7":{
         "Pets":"Reptiles"
      }
   },
   {
      "18.8":{
         "Pets":"Veterinary Medicine"
      }
   },
   {
      "19":"Pop Culture"
   },
   {
      "19.1":{
         "Pop Culture":"Celebrity Deaths"
      }
   },
   {
      "19.2":{
         "Pop Culture":"Celebrity Families"
      }
   },
   {
      "19.3":{
         "Pop Culture":"Celebrity Homes"
      }
   },
   {
      "19.4":{
         "Pop Culture":"Celebrity Pregnancy"
      }
   },
   {
      "19.5":{
         "Pop Culture":"Celebrity Relationships"
      }
   },
   {
      "19.6":{
         "Pop Culture":"Celebrity Scandal"
      }
   },
   {
      "19.7":{
         "Pop Culture":"Celebrity Style"
      }
   },
   {
      "20":"Real Estate"
   },
   {
      "20.1":{
         "Real Estate":"Apartments"
      }
   },
   {
      "20.1":{
         "Real Estate":"Retail Property"
      }
   },
   {
      "20.11":{
         "Real Estate":"Vacation Properties"
      }
   },
   {
      "20.2":{
         "Real Estate":"Developmental Sites"
      }
   },
   {
      "20.3":{
         "Real Estate":"Hotel Properties"
      }
   },
   {
      "20.4":{
         "Real Estate":"Houses"
      }
   },
   {
      "20.5":{
         "Real Estate":"Industrial Property"
      }
   },
   {
      "20.6":{
         "Real Estate":"Land and Farms"
      }
   },
   {
      "20.7":{
         "Real Estate":"Office Property"
      }
   },
   {
      "20.8":{
         "Real Estate":"Real Estate Buying and Selling"
      }
   },
   {
      "20.9":{
         "Real Estate":"Real Estate Renting and Leasing"
      }
   },
   {
      "21":"Religion & Spirituality"
   },
   {
      "21.1":{
         "Religion & Spirituality":"Agnosticism"
      }
   },
   {
      "21.1":{
         "Religion & Spirituality":"Spirituality"
      }
   },
   {
      "21.2":{
         "Religion & Spirituality":"Astrology"
      }
   },
   {
      "21.3":{
         "Religion & Spirituality":"Atheism"
      }
   },
   {
      "21.4":{
         "Religion & Spirituality":"Buddhism"
      }
   },
   {
      "21.5":{
         "Religion & Spirituality":"Christianity"
      }
   },
   {
      "21.6":{
         "Religion & Spirituality":"Hinduism"
      }
   },
   {
      "21.7":{
         "Religion & Spirituality":"Islam"
      }
   },
   {
      "21.8":{
         "Religion & Spirituality":"Judaism"
      }
   },
   {
      "21.9":{
         "Religion & Spirituality":"Sikhism"
      }
   },
   {
      "22":"Science"
   },
   {
      "22.1":{
         "Science":"Biological Sciences"
      }
   },
   {
      "22.2":{
         "Science":"Chemistry"
      }
   },
   {
      "22.3":{
         "Science":"Environment"
      }
   },
   {
      "22.4":{
         "Science":"Genetics"
      }
   },
   {
      "22.5":{
         "Science":"Geography"
      }
   },
   {
      "22.6":{
         "Science":"Geology"
      }
   },
   {
      "22.7":{
         "Science":"Physics"
      }
   },
   {
      "22.8":{
         "Science":"Space and Astronomy"
      }
   },
   {
      "23.1":{
         "Shopping":"Couponing"
      }
   },
   {
      "23":"Shopping"
   },
   {
      "24":"Sports"
   },
   {
      "24.1":{
         "Sports":"American Football"
      }
   },
   {
      "24.1":{
         "Sports":"Boxing"
      }
   },
   {
      "24.11":{
         "Sports":"Cheerleading"
      }
   },
   {
      "24.12":{
         "Sports":"College Sports"
      }
   },
   {
      "24.13":{
         "Sports":"Cricket"
      }
   },
   {
      "24.14":{
         "Sports":"Cycling"
      }
   },
   {
      "24.15":{
         "Sports":"Darts"
      }
   },
   {
      "24.16":{
         "Sports":"Disabled Sports"
      }
   },
   {
      "24.17":{
         "Sports":"Diving"
      }
   },
   {
      "24.18":{
         "Sports":"Equine Sports"
      }
   },
   {
      "24.18.1":{
         "Sports":{
            "Equine Sports":"Horse Racing"
         }
      }
   },
   {
      "24.19":{
         "Sports":"Extreme Sports"
      }
   },
   {
      "24.19.1":{
         "Sports":{
            "Extreme Sports":"Canoeing and Kayaking"
         }
      }
   },
   {
      "24.19.2":{
         "Sports":{
            "Extreme Sports":"Climbing"
         }
      }
   },
   {
      "24.19.3":{
         "Sports":{
            "Extreme Sports":"Paintball"
         }
      }
   },
   {
      "24.19.4":{
         "Sports":{
            "Extreme Sports":"Scuba Diving"
         }
      }
   },
   {
      "24.19.5":{
         "Sports":{
            "Extreme Sports":"Skateboarding"
         }
      }
   },
   {
      "24.19.6":{
         "Sports":{
            "Extreme Sports":"Snowboarding"
         }
      }
   },
   {
      "24.19.7":{
         "Sports":{
            "Extreme Sports":"Surfing and Bodyboarding"
         }
      }
   },
   {
      "24.19.8":{
         "Sports":{
            "Extreme Sports":"Waterskiing and Wakeboarding"
         }
      }
   },
   {
      "24.2":{
         "Sports":"Australian Rules Football"
      }
   },
   {
      "24.2":{
         "Sports":"Fantasy Sports"
      }
   },
   {
      "24.21":{
         "Sports":"Field Hockey"
      }
   },
   {
      "24.22":{
         "Sports":"Figure Skating"
      }
   },
   {
      "24.23":{
         "Sports":"Fishing Sports"
      }
   },
   {
      "24.24":{
         "Sports":"Golf"
      }
   },
   {
      "24.25":{
         "Sports":"Gymnastics"
      }
   },
   {
      "24.26":{
         "Sports":"Hunting and Shooting"
      }
   },
   {
      "24.27":{
         "Sports":"Ice Hockey"
      }
   },
   {
      "24.28":{
         "Sports":"Inline Skating"
      }
   },
   {
      "24.29":{
         "Sports":"Lacrosse"
      }
   },
   {
      "24.3":{
         "Sports":"Auto Racing"
      }
   },
   {
      "24.3.1":{
         "Sports":{
            "Auto Racing":"Motorcycle Sports"
         }
      }
   },
   {
      "24.3":{
         "Sports":"Martial Arts"
      }
   },
   {
      "24.31":{
         "Sports":"Olympic Sports"
      }
   },
   {
      "24.31.1":{
         "Sports":{
            "Olympic Sports":"Summer Olympic Sports"
         }
      }
   },
   {
      "24.31.2":{
         "Sports":{
            "Olympic Sports":"Winter Olympic Sports"
         }
      }
   },
   {
      "24.32":{
         "Sports":"Poker and Professional Gambling"
      }
   },
   {
      "24.33":{
         "Sports":"Rodeo"
      }
   },
   {
      "24.34":{
         "Sports":"Rowing"
      }
   },
   {
      "24.35":{
         "Sports":"Rugby"
      }
   },
   {
      "24.35.1":{
         "Sports":{
            "Rugby":"Rugby League"
         }
      }
   },
   {
      "24.35.2":{
         "Sports":{
            "Rugby":"Rugby Union"
         }
      }
   },
   {
      "24.36":{
         "Sports":"Sailing"
      }
   },
   {
      "24.37":{
         "Sports":"Skiing"
      }
   },
   {
      "24.38":{
         "Sports":"Snooker/Pool/Billiards"
      }
   },
   {
      "24.39":{
         "Sports":"Soccer"
      }
   },
   {
      "24.4":{
         "Sports":"Badminton"
      }
   },
   {
      "24.4":{
         "Sports":"Softball"
      }
   },
   {
      "24.41":{
         "Sports":"Squash"
      }
   },
   {
      "24.42":{
         "Sports":"Swimming"
      }
   },
   {
      "24.43":{
         "Sports":"Table Tennis"
      }
   },
   {
      "24.44":{
         "Sports":"Tennis"
      }
   },
   {
      "24.45":{
         "Sports":"Track and Field"
      }
   },
   {
      "24.46":{
         "Sports":"Volleyball"
      }
   },
   {
      "24.47":{
         "Sports":"Walking"
      }
   },
   {
      "24.48":{
         "Sports":"Water Polo"
      }
   },
   {
      "24.49":{
         "Sports":"Weightlifting"
      }
   },
   {
      "24.5":{
         "Sports":"Baseball"
      }
   },
   {
      "24.5":{
         "Sports":"Wrestling"
      }
   },
   {
      "24.6":{
         "Sports":"Basketball"
      }
   },
   {
      "24.7":{
         "Sports":"Beach Volleyball"
      }
   },
   {
      "24.8":{
         "Sports":"Bodybuilding"
      }
   },
   {
      "24.9":{
         "Sports":"Bowling"
      }
   },
   {
      "25":"Style & Fashion"
   },
   {
      "25.1":{
         "Style & Fashion":"Beauty"
      }
   },
   {
      "25.1.1":{
         "Style & Fashion":{
            "Beauty":"Hair Care"
         }
      }
   },
   {
      "25.1.2":{
         "Style & Fashion":{
            "Beauty":"Makeup and Accessories"
         }
      }
   },
   {
      "25.1.3":{
         "Style & Fashion":{
            "Beauty":"Nail Care"
         }
      }
   },
   {
      "25.1.4":{
         "Style & Fashion":{
            "Beauty":"Natural and Organic Beauty"
         }
      }
   },
   {
      "25.1.5":{
         "Style & Fashion":{
            "Beauty":"Perfume and Fragrance"
         }
      }
   },
   {
      "25.1.6":{
         "Style & Fashion":{
            "Beauty":"Skin Care"
         }
      }
   },
   {
      "25.1":{
         "Style & Fashion":"Women's Fashion"
      }
   },
   {
      "25.10.1":{
         "Style & Fashion":{
            "Women's Fashion":"Women's Accessories"
         }
      }
   },
   {
      "25.10.1.1":{
         "Style & Fashion":{
            "Women's Fashion":{
               "Women's Accessories":"Women's Glasses"
            }
         }
      }
   },
   {
      "25.10.1.2":{
         "Style & Fashion":{
            "Women's Fashion":{
               "Women's Accessories":"Women's Handbags and Wallets"
            }
         }
      }
   },
   {
      "25.10.1.3":{
         "Style & Fashion":{
            "Women's Fashion":{
               "Women's Accessories":"Women's Hats and Scarves"
            }
         }
      }
   },
   {
      "25.10.1.4":{
         "Style & Fashion":{
            "Women's Fashion":{
               "Women's Accessories":"Women's Jewelry and Watches"
            }
         }
      }
   },
   {
      "25.10.2":{
         "Style & Fashion":{
            "Women's Fashion":"Women's Clothing"
         }
      }
   },
   {
      "25.10.2.1":{
         "Style & Fashion":{
            "Women's Fashion":{
               "Women's Clothing":"Women's Business Wear"
            }
         }
      }
   },
   {
      "25.10.2.2":{
         "Style & Fashion":{
            "Women's Fashion":{
               "Women's Clothing":"Women's Casual Wear"
            }
         }
      }
   },
   {
      "25.10.2.3":{
         "Style & Fashion":{
            "Women's Fashion":{
               "Women's Clothing":"Women's Formal Wear"
            }
         }
      }
   },
   {
      "25.10.2.4":{
         "Style & Fashion":{
            "Women's Fashion":{
               "Women's Clothing":"Women's Intimates and Sleepwear"
            }
         }
      }
   },
   {
      "25.10.2.5":{
         "Style & Fashion":{
            "Women's Fashion":{
               "Women's Clothing":"Women's Outerwear"
            }
         }
      }
   },
   {
      "25.10.2.6":{
         "Style & Fashion":{
            "Women's Fashion":{
               "Women's Clothing":"Women's Sportswear"
            }
         }
      }
   },
   {
      "25.10.3":{
         "Style & Fashion":{
            "Women's Fashion":"Women's Shoes and Footwear"
         }
      }
   },
   {
      "25.2":{
         "Style & Fashion":"Body Art"
      }
   },
   {
      "25.3":{
         "Style & Fashion":"Children's Clothing"
      }
   },
   {
      "25.4":{
         "Style & Fashion":"Designer Clothing"
      }
   },
   {
      "25.5":{
         "Style & Fashion":"Fashion Trends"
      }
   },
   {
      "25.6":{
         "Style & Fashion":"High Fashion"
      }
   },
   {
      "25.7":{
         "Style & Fashion":"Men's Fashion"
      }
   },
   {
      "25.7.1":{
         "Style & Fashion":{
            "Men's Fashion":"Men's Accessories"
         }
      }
   },
   {
      "25.7.1.1":{
         "Style & Fashion":{
            "Men's Fashion":{
               "Men's Accessories":"Men's Jewelry and Watches"
            }
         }
      }
   },
   {
      "25.7.2":{
         "Style & Fashion":{
            "Men's Fashion":"Men's Clothing"
         }
      }
   },
   {
      "25.7.2.1":{
         "Style & Fashion":{
            "Men's Fashion":{
               "Men's Clothing":"Men's Business Wear"
            }
         }
      }
   },
   {
      "25.7.2.2":{
         "Style & Fashion":{
            "Men's Fashion":{
               "Men's Clothing":"Men's Casual Wear"
            }
         }
      }
   },
   {
      "25.7.2.3":{
         "Style & Fashion":{
            "Men's Fashion":{
               "Men's Clothing":"Men's Formal Wear"
            }
         }
      }
   },
   {
      "25.7.2.4":{
         "Style & Fashion":{
            "Men's Fashion":{
               "Men's Clothing":"Men's Outerwear"
            }
         }
      }
   },
   {
      "25.7.2.5":{
         "Style & Fashion":{
            "Men's Fashion":{
               "Men's Clothing":"Men's Sportswear"
            }
         }
      }
   },
   {
      "25.7.2.6":{
         "Style & Fashion":{
            "Men's Fashion":{
               "Men's Clothing":"Men's Underwear and Sleepwear"
            }
         }
      }
   },
   {
      "25.7.3":{
         "Style & Fashion":{
            "Men's Fashion":"Men's Shoes and Footwear"
         }
      }
   },
   {
      "25.8":{
         "Style & Fashion":"Personal Care"
      }
   },
   {
      "25.8.1":{
         "Style & Fashion":{
            "Personal Care":"Bath and Shower"
         }
      }
   },
   {
      "25.8.2":{
         "Style & Fashion":{
            "Personal Care":"Deodorant and Antiperspirant"
         }
      }
   },
   {
      "25.8.3":{
         "Style & Fashion":{
            "Personal Care":"Oral care"
         }
      }
   },
   {
      "25.8.4":{
         "Style & Fashion":{
            "Personal Care":"Shaving"
         }
      }
   },
   {
      "25.9":{
         "Style & Fashion":"Street Style"
      }
   },
   {
      "26":"Technology & Computing"
   },
   {
      "26.1":{
         "Technology & Computing":"Artificial Intelligence"
      }
   },
   {
      "26.2":{
         "Technology & Computing":"Augmented Reality"
      }
   },
   {
      "26.3":{
         "Technology & Computing":"Computing"
      }
   },
   {
      "26.3.1":{
         "Technology & Computing":{
            "Computing":"Computer Networking"
         }
      }
   },
   {
      "26.3.2":{
         "Technology & Computing":{
            "Computing":"Computer Peripherals"
         }
      }
   },
   {
      "26.3.3":{
         "Technology & Computing":{
            "Computing":"Computer Software and Applications"
         }
      }
   },
   {
      "26.3.3.1":{
         "Technology & Computing":{
            "Computing":{
               "Computer Software and Applications":"3-D Graphics"
            }
         }
      }
   },
   {
      "26.3.3.10":{
         "Technology & Computing":{
            "Computing":{
               "Computer Software and Applications":"Photo Editing Software"
            }
         }
      }
   },
   {
      "26.3.3.11":{
         "Technology & Computing":{
            "Computing":{
               "Computer Software and Applications":"Shareware and Freeware"
            }
         }
      }
   },
   {
      "26.3.3.12":{
         "Technology & Computing":{
            "Computing":{
               "Computer Software and Applications":"Video Software"
            }
         }
      }
   },
   {
      "26.3.3.13":{
         "Technology & Computing":{
            "Computing":{
               "Computer Software and Applications":"Web Conferencing"
            }
         }
      }
   },
   {
      "26.3.3.2":{
         "Technology & Computing":{
            "Computing":{
               "Computer Software and Applications":"Antivirus Software"
            }
         }
      }
   },
   {
      "26.3.3.3":{
         "Technology & Computing":{
            "Computing":{
               "Computer Software and Applications":"Browsers"
            }
         }
      }
   },
   {
      "26.3.3.4":{
         "Technology & Computing":{
            "Computing":{
               "Computer Software and Applications":"Computer Animation"
            }
         }
      }
   },
   {
      "26.3.3.5":{
         "Technology & Computing":{
            "Computing":{
               "Computer Software and Applications":"Databases"
            }
         }
      }
   },
   {
      "26.3.3.6":{
         "Technology & Computing":{
            "Computing":{
               "Computer Software and Applications":"Desktop Publishing"
            }
         }
      }
   },
   {
      "26.3.3.7":{
         "Technology & Computing":{
            "Computing":{
               "Computer Software and Applications":"Digital Audio"
            }
         }
      }
   },
   {
      "26.3.3.8":{
         "Technology & Computing":{
            "Computing":{
               "Computer Software and Applications":"Graphics Software"
            }
         }
      }
   },
   {
      "26.3.3.9":{
         "Technology & Computing":{
            "Computing":{
               "Computer Software and Applications":"Operating Systems"
            }
         }
      }
   },
   {
      "26.3.4":{
         "Technology & Computing":{
            "Computing":"Data Storage and Warehousing"
         }
      }
   },
   {
      "26.3.5":{
         "Technology & Computing":{
            "Computing":"Desktops"
         }
      }
   },
   {
      "26.3.6":{
         "Technology & Computing":{
            "Computing":"Information and Network Security"
         }
      }
   },
   {
      "26.3.7":{
         "Technology & Computing":{
            "Computing":"Internet"
         }
      }
   },
   {
      "26.3.7.1":{
         "Technology & Computing":{
            "Computing":{
               "Internet":"Cloud Computing"
            }
         }
      }
   },
   {
      "26.3.7.10":{
         "Technology & Computing":{
            "Computing":{
               "Internet":"Web Development"
            }
         }
      }
   },
   {
      "26.3.7.11":{
         "Technology & Computing":{
            "Computing":{
               "Internet":"Web Hosting"
            }
         }
      }
   },
   {
      "26.3.7.2":{
         "Technology & Computing":{
            "Computing":{
               "Internet":"Email"
            }
         }
      }
   },
   {
      "26.3.7.3":{
         "Technology & Computing":{
            "Computing":{
               "Internet":"Internet for Beginners"
            }
         }
      }
   },
   {
      "26.3.7.4":{
         "Technology & Computing":{
            "Computing":{
               "Internet":"Internet of Things"
            }
         }
      }
   },
   {
      "26.3.7.5":{
         "Technology & Computing":{
            "Computing":{
               "Internet":"IT and Internet Support"
            }
         }
      }
   },
   {
      "26.3.7.6":{
         "Technology & Computing":{
            "Computing":{
               "Internet":"Search"
            }
         }
      }
   },
   {
      "26.3.7.7":{
         "Technology & Computing":{
            "Computing":{
               "Internet":"Social Networking"
            }
         }
      }
   },
   {
      "26.3.7.8":{
         "Technology & Computing":{
            "Computing":{
               "Internet":"Web Conferencing"
            }
         }
      }
   },
   {
      "26.3.7.9":{
         "Technology & Computing":{
            "Computing":{
               "Internet":"Web Design and HTML"
            }
         }
      }
   },
   {
      "26.3.8":{
         "Technology & Computing":{
            "Computing":"Laptops"
         }
      }
   },
   {
      "26.3.9":{
         "Technology & Computing":{
            "Computing":"Programming Languages"
         }
      }
   },
   {
      "26.4":{
         "Technology & Computing":"Consumer Electronics"
      }
   },
   {
      "26.4.1":{
         "Technology & Computing":{
            "Consumer Electronics":"Cameras and Camcorders"
         }
      }
   },
   {
      "26.4.2":{
         "Technology & Computing":{
            "Consumer Electronics":"Home Entertainment Systems"
         }
      }
   },
   {
      "26.4.3":{
         "Technology & Computing":{
            "Consumer Electronics":"Smartphones"
         }
      }
   },
   {
      "26.4.4":{
         "Technology & Computing":{
            "Consumer Electronics":"Tablets and E-readers"
         }
      }
   },
   {
      "26.4.5":{
         "Technology & Computing":{
            "Consumer Electronics":"Wearable Technology"
         }
      }
   },
   {
      "26.5":{
         "Technology & Computing":"Robotics"
      }
   },
   {
      "26.6":{
         "Technology & Computing":"Virtual Reality"
      }
   },
   {
      "27":"Television"
   },
   {
      "27.1":{
         "Television":"Animation TV"
      }
   },
   {
      "27.1":{
         "Television":"Soap Opera TV"
      }
   },
   {
      "27.11":{
         "Television":"Special Interest TV"
      }
   },
   {
      "27.12":{
         "Television":"Sports TV"
      }
   },
   {
      "27.2":{
         "Television":"Children's TV"
      }
   },
   {
      "27.3":{
         "Television":"Comedy TV"
      }
   },
   {
      "27.4":{
         "Television":"Drama TV"
      }
   },
   {
      "27.5":{
         "Television":"Factual TV"
      }
   },
   {
      "27.6":{
         "Television":"Holiday TV"
      }
   },
   {
      "27.7":{
         "Television":"Music TV"
      }
   },
   {
      "27.8":{
         "Television":"Reality TV"
      }
   },
   {
      "27.9":{
         "Television":"Science Fiction TV"
      }
   },
   {
      "28":"Travel"
   },
   {
      "28.1":{
         "Travel":"Travel Accessories"
      }
   },
   {
      "28.2":{
         "Travel":"Travel Locations"
      }
   },
   {
      "28.2.1":{
         "Travel":{
            "Travel Locations":"Africa Travel"
         }
      }
   },
   {
      "28.2.2":{
         "Travel":{
            "Travel Locations":"Asia Travel"
         }
      }
   },
   {
      "28.2.3":{
         "Travel":{
            "Travel Locations":"Australia and Oceania Travel"
         }
      }
   },
   {
      "28.2.4":{
         "Travel":{
            "Travel Locations":"Europe Travel"
         }
      }
   },
   {
      "28.2.5":{
         "Travel":{
            "Travel Locations":"North America Travel"
         }
      }
   },
   {
      "28.2.6":{
         "Travel":{
            "Travel Locations":"Polar Travel"
         }
      }
   },
   {
      "28.2.7":{
         "Travel":{
            "Travel Locations":"South America Travel"
         }
      }
   },
   {
      "28.3":{
         "Travel":"Travel Preparation"
      }
   },
   {
      "28.4":{
         "Travel":"Travel Type"
      }
   },
   {
      "28.4.1":{
         "Travel":{
            "Travel Type":"Adventure Travel"
         }
      }
   },
   {
      "28.4.10":{
         "Travel":{
            "Travel Type":"Family Travel"
         }
      }
   },
   {
      "28.4.11":{
         "Travel":{
            "Travel Type":"Honeymoons and Getaways"
         }
      }
   },
   {
      "28.4.12":{
         "Travel":{
            "Travel Type":"Hotels and Motels"
         }
      }
   },
   {
      "28.4.13":{
         "Travel":{
            "Travel Type":"Rail Travel"
         }
      }
   },
   {
      "28.4.14":{
         "Travel":{
            "Travel Type":"Road Trips"
         }
      }
   },
   {
      "28.4.15":{
         "Travel":{
            "Travel Type":"Spas"
         }
      }
   },
   {
      "28.4.2":{
         "Travel":{
            "Travel Type":"Air Travel"
         }
      }
   },
   {
      "28.4.3":{
         "Travel":{
            "Travel Type":"Beach Travel"
         }
      }
   },
   {
      "28.4.4":{
         "Travel":{
            "Travel Type":"Bed & Breakfasts"
         }
      }
   },
   {
      "28.4.5":{
         "Travel":{
            "Travel Type":"Budget Travel"
         }
      }
   },
   {
      "28.4.6":{
         "Travel":{
            "Travel Type":"Business Travel"
         }
      }
   },
   {
      "28.4.7":{
         "Travel":{
            "Travel Type":"Camping"
         }
      }
   },
   {
      "28.4.8":{
         "Travel":{
            "Travel Type":"Cruises"
         }
      }
   },
   {
      "28.4.9":{
         "Travel":{
            "Travel Type":"Day Trips"
         }
      }
   },
   {
      "29":"Video Gaming"
   },
   {
      "29.1":{
         "Video Gaming":"Console Games"
      }
   },
   {
      "29.2":{
         "Video Gaming":"eSports"
      }
   },
   {
      "29.3":{
         "Video Gaming":"Mobile Games"
      }
   },
   {
      "29.4":{
         "Video Gaming":"PC Games"
      }
   },
   {
      "29.5":{
         "Video Gaming":"Video Game Genres"
      }
   },
   {
      "29.5.1":{
         "Video Gaming":{
            "Video Game Genres":"Action Video Games"
         }
      }
   },
   {
      "29.5.10":{
         "Video Gaming":{
            "Video Game Genres":"Role-Playing Video Games"
         }
      }
   },
   {
      "29.5.11":{
         "Video Gaming":{
            "Video Game Genres":"Simulation Video Games"
         }
      }
   },
   {
      "29.5.12":{
         "Video Gaming":{
            "Video Game Genres":"Sports Video Games"
         }
      }
   },
   {
      "29.5.13":{
         "Video Gaming":{
            "Video Game Genres":"Strategy Video Games"
         }
      }
   },
   {
      "29.5.2":{
         "Video Gaming":{
            "Video Game Genres":"Action-Adventure Video Games"
         }
      }
   },
   {
      "29.5.3":{
         "Video Gaming":{
            "Video Game Genres":"Adventure Video Games"
         }
      }
   },
   {
      "29.5.4":{
         "Video Gaming":{
            "Video Game Genres":"Casual Games"
         }
      }
   },
   {
      "29.5.5":{
         "Video Gaming":{
            "Video Game Genres":"Educational Video Games"
         }
      }
   },
   {
      "29.5.6":{
         "Video Gaming":{
            "Video Game Genres":"Exercise and Fitness Video Games"
         }
      }
   },
   {
      "29.5.7":{
         "Video Gaming":{
            "Video Game Genres":"MMOs"
         }
      }
   },
   {
      "29.5.8":{
         "Video Gaming":{
            "Video Game Genres":"Music and Party Video Games"
         }
      }
   },
   {
      "29.5.9":{
         "Video Gaming":{
            "Video Game Genres":"Puzzle Video Games"
         }
      }
   },
   {
      "CC":"Content Channel"
   },
   {
      "CC.1":{
         "Content Channel":"Editorial/Professional"
      }
   },
   {
      "CC.2":{
         "Content Channel":"Email"
      }
   },
   {
      "CC.3":{
         "Content Channel":"Forum/Community"
      }
   },
   {
      "CC.4":{
         "Content Channel":"Game"
      }
   },
   {
      "CC.5":{
         "Content Channel":"Marketplace/eCommerce"
      }
   },
   {
      "CC.6":{
         "Content Channel":"Search Engine/Listings"
      }
   },
   {
      "CC.7":{
         "Content Channel":"Social"
      }
   },
   {
      "CC.8":{
         "Content Channel":"Utility/Online Tool"
      }
   },
   {
      "CC.9":{
         "Content Channel":"Voice Activated Channels"
      }
   },
   {
      "CT":"Content Type"
   },
   {
      "CT.1":{
         "Content Type":"Academic/ResearchConent"
      }
   },
   {
      "CT.2":{
         "Content Type":"Chat/IM/Comments"
      }
   },
   {
      "CT.3":{
         "Content Type":"Educational Content"
      }
   },
   {
      "CT.4":{
         "Content Type":"Entertainment Content"
      }
   },
   {
      "CT.5":{
         "Content Type":"Feature"
      }
   },
   {
      "CT.6":{
         "Content Type":"General Social"
      }
   },
   {
      "CT.7":{
         "Content Type":"Instructional Content"
      }
   },
   {
      "CT.8":{
         "Content Type":"Interactive Content"
      }
   },
   {
      "CT.9":{
         "Content Type":"Listings/Classifieds/Product Listings/Search Results"
      }
   },
   {
      "CT.10":{
         "Content Type":"News"
      }
   },
   {
      "CT.11":{
         "Content Type":"Review"
      }
   },
   {
      "CF":"Content Media Format"
   },
   {
      "CF.1":{
         "Content Media Format":"Audio"
      }
   },
   {
      "CF.2":{
         "Content Media Format":"Images/Galleries"
      }
   },
   {
      "CF.3":{
         "Content Media Format":"Interactive"
      }
   },
   {
      "CF.4":{
         "Content Media Format":"Mixed"
      }
   },
   {
      "CF.5":{
         "Content Media Format":"Textual"
      }
   },
   {
      "CF.6":{
         "Content Media Format":"Video"
      }
   },
   {
      "CF.7":{
         "Content Media Format":"VR/AR"
      }
   },
   {
      "CL":"Content Language"
   },
   {
      "CL.aa":{
         "Content Language":"Afar"
      }
   },
   {
      "CL.ab":{
         "Content Language":"Abkhaz"
      }
   },
   {
      "CL.ae":{
         "Content Language":"Avestan"
      }
   },
   {
      "CL.af":{
         "Content Language":"Afrikaans"
      }
   },
   {
      "CL.ak":{
         "Content Language":"Akan"
      }
   },
   {
      "CL.am":{
         "Content Language":"Amharic"
      }
   },
   {
      "CL.an":{
         "Content Language":"Aragonese"
      }
   },
   {
      "CL.ar":{
         "Content Language":"Arabic"
      }
   },
   {
      "CL.as":{
         "Content Language":"Assamese"
      }
   },
   {
      "CL.av":{
         "Content Language":"Avaric"
      }
   },
   {
      "CL.ay":{
         "Content Language":"Aymara"
      }
   },
   {
      "CL.az":{
         "Content Language":"Azerbaijani"
      }
   },
   {
      "CL.ba":{
         "Content Language":"Bashkir"
      }
   },
   {
      "CL.be":{
         "Content Language":"Belarusian"
      }
   },
   {
      "CL.bg":{
         "Content Language":"Bulgarian"
      }
   },
   {
      "CL.bh":{
         "Content Language":"Bihari"
      }
   },
   {
      "CL.bi":{
         "Content Language":"Bislama"
      }
   },
   {
      "CL.bm":{
         "Content Language":"Bambara"
      }
   },
   {
      "CL.bn":{
         "Content Language":"Bengali"
      }
   },
   {
      "CL.bo":{
         "Content Language":"Tibetan"
      }
   },
   {
      "CL.br":{
         "Content Language":"Breton"
      }
   },
   {
      "CL.bs":{
         "Content Language":"Bosnian"
      }
   },
   {
      "CL.ca":{
         "Content Language":"Catalan"
      }
   },
   {
      "CL.ce":{
         "Content Language":"Chechen"
      }
   },
   {
      "CL.ch":{
         "Content Language":"Chamorro"
      }
   },
   {
      "CL.co":{
         "Content Language":"Corsican"
      }
   },
   {
      "CL.cr":{
         "Content Language":"Cree"
      }
   },
   {
      "CL.cs":{
         "Content Language":"Czech"
      }
   },
   {
      "CL.cu":{
         "Content Language":"Old Church Slavonic"
      }
   },
   {
      "CL.cv":{
         "Content Language":"Chuvash"
      }
   },
   {
      "CL.cy":{
         "Content Language":"Welsh"
      }
   },
   {
      "CL.da":{
         "Content Language":"Danish"
      }
   },
   {
      "CL.de":{
         "Content Language":"German"
      }
   },
   {
      "CL.dv":{
         "Content Language":"Divehi"
      }
   },
   {
      "CL.dz":{
         "Content Language":"Dzongkha"
      }
   },
   {
      "CL.ee":{
         "Content Language":"Ewe"
      }
   },
   {
      "CL.el":{
         "Content Language":"Greek"
      }
   },
   {
      "CL.en":{
         "Content Language":"English"
      }
   },
   {
      "CL.eo":{
         "Content Language":"Esperanto"
      }
   },
   {
      "CL.es":{
         "Content Language":"Spanish"
      }
   },
   {
      "CL.et":{
         "Content Language":"Estonian"
      }
   },
   {
      "CL.eu":{
         "Content Language":"Basque"
      }
   },
   {
      "CL.fa":{
         "Content Language":"Farsi"
      }
   },
   {
      "CL.ff":{
         "Content Language":"Fula"
      }
   },
   {
      "CL.fi":{
         "Content Language":"Finnish"
      }
   },
   {
      "CL.fj":{
         "Content Language":"Fijian"
      }
   },
   {
      "CL.fo":{
         "Content Language":"Faroese"
      }
   },
   {
      "CL.fr":{
         "Content Language":"French"
      }
   },
   {
      "CL.fy":{
         "Content Language":"Western Frisian"
      }
   },
   {
      "CL.ga":{
         "Content Language":"Irish"
      }
   },
   {
      "CL.gd":{
         "Content Language":"Scottish Gaelic"
      }
   },
   {
      "CL.gl":{
         "Content Language":"Galician"
      }
   },
   {
      "CL.gn":{
         "Content Language":"Guarani"
      }
   },
   {
      "CL.gu":{
         "Content Language":"Gujarati"
      }
   },
   {
      "CL.gv":{
         "Content Language":"Manx"
      }
   },
   {
      "CL.ha":{
         "Content Language":"Hausa"
      }
   },
   {
      "CL.he":{
         "Content Language":"Hebrew"
      }
   },
   {
      "CL.hi":{
         "Content Language":"Hindi"
      }
   },
   {
      "CL.ho":{
         "Content Language":"Hiri Motu"
      }
   },
   {
      "CL.hr":{
         "Content Language":"Croatian"
      }
   },
   {
      "CL.ht":{
         "Content Language":"Haitian"
      }
   },
   {
      "CL.hu":{
         "Content Language":"Hungarian"
      }
   },
   {
      "CL.hy":{
         "Content Language":"Armenian"
      }
   },
   {
      "CL.hz":{
         "Content Language":"Herero"
      }
   },
   {
      "CL.ia":{
         "Content Language":"Interlingua"
      }
   },
   {
      "CL.id":{
         "Content Language":"Indonesian"
      }
   },
   {
      "CL.ie":{
         "Content Language":"Interlingue"
      }
   },
   {
      "CL.ig":{
         "Content Language":"Igbo"
      }
   },
   {
      "CL.ii":{
         "Content Language":"Nuosu"
      }
   },
   {
      "CL.ik":{
         "Content Language":"Inupiaq"
      }
   },
   {
      "CL.io":{
         "Content Language":"Ido"
      }
   },
   {
      "CL.is":{
         "Content Language":"Icelandic"
      }
   },
   {
      "CL.it":{
         "Content Language":"Italian"
      }
   },
   {
      "CL.iu":{
         "Content Language":"Inuktitut"
      }
   },
   {
      "CL.ja":{
         "Content Language":"Japanese"
      }
   },
   {
      "CL.jv":{
         "Content Language":"Javanese"
      }
   },
   {
      "CL.ka":{
         "Content Language":"Georgian"
      }
   },
   {
      "CL.kg":{
         "Content Language":"Kongo"
      }
   },
   {
      "CL.ki":{
         "Content Language":"Kikuyu"
      }
   },
   {
      "CL.kj":{
         "Content Language":"Kwanyama"
      }
   },
   {
      "CL.kk":{
         "Content Language":"Kazakh"
      }
   },
   {
      "CL.kl":{
         "Content Language":"Kalaallisut"
      }
   },
   {
      "CL.km":{
         "Content Language":"Khmer"
      }
   },
   {
      "CL.kn":{
         "Content Language":"Kannada"
      }
   },
   {
      "CL.ko":{
         "Content Language":"Korean"
      }
   },
   {
      "CL.kr":{
         "Content Language":"Kanuri"
      }
   },
   {
      "CL.ks":{
         "Content Language":"Kashmiri"
      }
   },
   {
      "CL.ku":{
         "Content Language":"Kurdish"
      }
   },
   {
      "CL.kv":{
         "Content Language":"Komi"
      }
   },
   {
      "CL.kw":{
         "Content Language":"Cornish"
      }
   },
   {
      "CL.ky":{
         "Content Language":"Kyrgyz"
      }
   },
   {
      "CL.la":{
         "Content Language":"Latin"
      }
   },
   {
      "CL.lb":{
         "Content Language":"Luxembourgish"
      }
   },
   {
      "CL.lg":{
         "Content Language":"Ganda"
      }
   },
   {
      "CL.li":{
         "Content Language":"Limburgish"
      }
   },
   {
      "CL.ln":{
         "Content Language":"Lingala"
      }
   },
   {
      "CL.lo":{
         "Content Language":"Lao"
      }
   },
   {
      "CL.lt":{
         "Content Language":"Lithuanian"
      }
   },
   {
      "CL.lu":{
         "Content Language":"Luba-Katanga"
      }
   },
   {
      "CL.lv":{
         "Content Language":"Latvian"
      }
   },
   {
      "CL.mg":{
         "Content Language":"Malagasy"
      }
   },
   {
      "CL.mh":{
         "Content Language":"Marshallese"
      }
   },
   {
      "CL.mi":{
         "Content Language":"Māori"
      }
   },
   {
      "CL.mk":{
         "Content Language":"Macedonian"
      }
   },
   {
      "CL.ml":{
         "Content Language":"Malayalam"
      }
   },
   {
      "CL.mn":{
         "Content Language":"Mongolian"
      }
   },
   {
      "CL.mr":{
         "Content Language":"Marathi"
      }
   },
   {
      "CL.ms":{
         "Content Language":"Malay"
      }
   },
   {
      "CL.mt":{
         "Content Language":"Maltese"
      }
   },
   {
      "CL.my":{
         "Content Language":"Burmese"
      }
   },
   {
      "CL.na":{
         "Content Language":"Nauruan"
      }
   },
   {
      "CL.nb":{
         "Content Language":"Norwegian Bokmal"
      }
   },
   {
      "CL.nd":{
         "Content Language":"Northern Ndebele"
      }
   },
   {
      "CL.ne":{
         "Content Language":"Nepali"
      }
   },
   {
      "CL.ng":{
         "Content Language":"Ndonga"
      }
   },
   {
      "CL.nl":{
         "Content Language":"Dutch"
      }
   },
   {
      "CL.nn":{
         "Content Language":"Norwegian Nynorsk"
      }
   },
   {
      "CL.no":{
         "Content Language":"Norwegian"
      }
   },
   {
      "CL.nr":{
         "Content Language":"Southern Ndebele"
      }
   },
   {
      "CL.nv":{
         "Content Language":"Navajo"
      }
   },
   {
      "CL.ny":{
         "Content Language":"Chichewa"
      }
   },
   {
      "CL.oc":{
         "Content Language":"Occitan"
      }
   },
   {
      "CL.oj":{
         "Content Language":"Ojibwe"
      }
   },
   {
      "CL.om":{
         "Content Language":"Oromo"
      }
   },
   {
      "CL.or":{
         "Content Language":"Oriya"
      }
   },
   {
      "CL.os":{
         "Content Language":"Ossetian"
      }
   },
   {
      "CL.pa":{
         "Content Language":"Punjabi"
      }
   },
   {
      "CL.pi":{
         "Content Language":"Pali"
      }
   },
   {
      "CL.pl":{
         "Content Language":"Polish"
      }
   },
   {
      "CL.ps":{
         "Content Language":"Pashto"
      }
   },
   {
      "CL.pt":{
         "Content Language":"Portuguese"
      }
   },
   {
      "CL.qu":{
         "Content Language":"Quechua"
      }
   },
   {
      "CL.rm":{
         "Content Language":"Romansh"
      }
   },
   {
      "CL.rn":{
         "Content Language":"Kirundi"
      }
   },
   {
      "CL.ro":{
         "Content Language":"Romanian"
      }
   },
   {
      "CL.ru":{
         "Content Language":"Russian"
      }
   },
   {
      "CL.rw":{
         "Content Language":"Kinyarwanda"
      }
   },
   {
      "CL.sa":{
         "Content Language":"Sanskrit"
      }
   },
   {
      "CL.sc":{
         "Content Language":"Sardinian"
      }
   },
   {
      "CL.sd":{
         "Content Language":"Sindhi"
      }
   },
   {
      "CL.se":{
         "Content Language":"Northern Sami"
      }
   },
   {
      "CL.sg":{
         "Content Language":"Sango"
      }
   },
   {
      "CL.si":{
         "Content Language":"Sinhala"
      }
   },
   {
      "CL.sk":{
         "Content Language":"Slovak"
      }
   },
   {
      "CL.sl":{
         "Content Language":"Slovene"
      }
   },
   {
      "CL.sm":{
         "Content Language":"Samoan"
      }
   },
   {
      "CL.sn":{
         "Content Language":"Shona"
      }
   },
   {
      "CL.so":{
         "Content Language":"Somali"
      }
   },
   {
      "CL.sq":{
         "Content Language":"Albanian"
      }
   },
   {
      "CL.sr":{
         "Content Language":"Serbian"
      }
   },
   {
      "CL.ss":{
         "Content Language":"Swati"
      }
   },
   {
      "CL.st":{
         "Content Language":"Southern Sotho"
      }
   },
   {
      "CL.su":{
         "Content Language":"Sundanese"
      }
   },
   {
      "CL.sv":{
         "Content Language":"Swedish"
      }
   },
   {
      "CL.sw":{
         "Content Language":"Swahili"
      }
   },
   {
      "CL.ta":{
         "Content Language":"Tamil"
      }
   },
   {
      "CL.te":{
         "Content Language":"Telugu"
      }
   },
   {
      "CL.tg":{
         "Content Language":"Tajik"
      }
   },
   {
      "CL.th":{
         "Content Language":"Thai"
      }
   },
   {
      "CL.ti":{
         "Content Language":"Tigrinya"
      }
   },
   {
      "CL.tk":{
         "Content Language":"Turkmen"
      }
   },
   {
      "CL.tl":{
         "Content Language":"Tagalog"
      }
   },
   {
      "CL.tn":{
         "Content Language":"Tswana"
      }
   },
   {
      "CL.to":{
         "Content Language":"Tonga"
      }
   },
   {
      "CL.tr":{
         "Content Language":"Turkish"
      }
   },
   {
      "CL.ts":{
         "Content Language":"Tsonga"
      }
   },
   {
      "CL.tt":{
         "Content Language":"Tatar"
      }
   },
   {
      "CL.tw":{
         "Content Language":"Twi"
      }
   },
   {
      "CL.ty":{
         "Content Language":"Tahitian"
      }
   },
   {
      "CL.ug":{
         "Content Language":"Uyghur"
      }
   },
   {
      "CL.uk":{
         "Content Language":"Ukrainian"
      }
   },
   {
      "CL.ur":{
         "Content Language":"Urdu"
      }
   },
   {
      "CL.uz":{
         "Content Language":"Uzbek"
      }
   },
   {
      "CL.ve":{
         "Content Language":"Venda"
      }
   },
   {
      "CL.vi":{
         "Content Language":"Vietnamese"
      }
   },
   {
      "CL.vo":{
         "Content Language":"Volapuk"
      }
   },
   {
      "CL.wa":{
         "Content Language":"Walloon"
      }
   },
   {
      "CL.wo":{
         "Content Language":"Wolof"
      }
   },
   {
      "CL.xh":{
         "Content Language":"Xhosa"
      }
   },
   {
      "CL.yi":{
         "Content Language":"Yiddish"
      }
   },
   {
      "CL.yo":{
         "Content Language":"Yoruba"
      }
   },
   {
      "CL.za":{
         "Content Language":"Zhuang"
      }
   },
   {
      "CL.zh":{
         "Content Language":"Chinese"
      }
   },
   {
      "CL.zu":{
         "Content Language":"Zulu"
      }
   },
   {
      "CM":"Content Source"
   },
   {
      "CM.1":{
         "Content Source":"Professionally Produced"
      }
   },
   {
      "CM.2":{
         "Content Source":"User Generated"
      }
   },
   {
      "CM.3":{
         "Content Source":"Aggregated/Curated"
      }
   },
   {
      "CG":"Content Source Geo"
   },
   {
      "CG.co":{
         "Content Source Geo":"Continent"
      }
   },
   {
      "CG.co.1":{
         "Content Source Geo":{
            "Continent":"Asia"
         }
      }
   },
   {
      "CG.co.2":{
         "Content Source Geo":{
            "Continent":"Africa"
         }
      }
   },
   {
      "CG.co.3":{
         "Content Source Geo":{
            "Continent":"North America"
         }
      }
   },
   {
      "CG.co.4":{
         "Content Source Geo":{
            "Continent":"South America"
         }
      }
   },
   {
      "CG.co.5":{
         "Content Source Geo":{
            "Continent":"Antarctica"
         }
      }
   },
   {
      "CG.co.6":{
         "Content Source Geo":{
            "Continent":"Europe"
         }
      }
   },
   {
      "CG.co.7":{
         "Content Source Geo":{
            "Continent":"Antarctica"
         }
      }
   },
   {
      "CG.cn":{
         "Content Source Geo":"Country"
      }
   },
   {
      "CG.cn.AFG":{
         "Content Source Geo":{
            "Country":"Afghanistan"
         }
      }
   },
   {
      "CG.cn.ALA":{
         "Content Source Geo":{
            "Country":"Aland Islands"
         }
      }
   },
   {
      "CG.cn.ALB":{
         "Content Source Geo":{
            "Country":"Albania"
         }
      }
   },
   {
      "CG.cn.DZA":{
         "Content Source Geo":{
            "Country":"Algeria"
         }
      }
   },
   {
      "CG.cn.ASM":{
         "Content Source Geo":{
            "Country":"American Samoa"
         }
      }
   },
   {
      "CG.cn.AND":{
         "Content Source Geo":{
            "Country":"Andorra"
         }
      }
   },
   {
      "CG.cn.AGO":{
         "Content Source Geo":{
            "Country":"Angola"
         }
      }
   },
   {
      "CG.cn.AIA":{
         "Content Source Geo":{
            "Country":"Anguilla"
         }
      }
   },
   {
      "CG.cn.ATA":{
         "Content Source Geo":{
            "Country":"Antarctica"
         }
      }
   },
   {
      "CG.cn.ATG":{
         "Content Source Geo":{
            "Country":"Antigua and Barbuda"
         }
      }
   },
   {
      "CG.cn.ARG":{
         "Content Source Geo":{
            "Country":"Argentina"
         }
      }
   },
   {
      "CG.cn.ARM":{
         "Content Source Geo":{
            "Country":"Armenia"
         }
      }
   },
   {
      "CG.cn.ABW":{
         "Content Source Geo":{
            "Country":"Aruba"
         }
      }
   },
   {
      "CG.cn.AUS":{
         "Content Source Geo":{
            "Country":"Australia"
         }
      }
   },
   {
      "CG.cn.AUT":{
         "Content Source Geo":{
            "Country":"Austria"
         }
      }
   },
   {
      "CG.cn.AZE":{
         "Content Source Geo":{
            "Country":"Azerbaijan"
         }
      }
   },
   {
      "CG.cn.BHR":{
         "Content Source Geo":{
            "Country":"Bahrain"
         }
      }
   },
   {
      "CG.cn.BGD":{
         "Content Source Geo":{
            "Country":"Bangladesh"
         }
      }
   },
   {
      "CG.cn.BRB":{
         "Content Source Geo":{
            "Country":"Barbados"
         }
      }
   },
   {
      "CG.cn.BLR":{
         "Content Source Geo":{
            "Country":"Belarus"
         }
      }
   },
   {
      "CG.cn.BEL":{
         "Content Source Geo":{
            "Country":"Belgium"
         }
      }
   },
   {
      "CG.cn.BLZ":{
         "Content Source Geo":{
            "Country":"Belize"
         }
      }
   },
   {
      "CG.cn.BEN":{
         "Content Source Geo":{
            "Country":"Benin"
         }
      }
   },
   {
      "CG.cn.BMU":{
         "Content Source Geo":{
            "Country":"Bermuda"
         }
      }
   },
   {
      "CG.cn.BTN":{
         "Content Source Geo":{
            "Country":"Bhutan"
         }
      }
   },
   {
      "CG.cn.VEN":{
         "Content Source Geo":{
            "Country":"Bolivarian Republic of Venezuela"
         }
      }
   },
   {
      "CG.cn.BOL":{
         "Content Source Geo":{
            "Country":"Bolivia"
         }
      }
   },
   {
      "CG.cn.BES":{
         "Content Source Geo":{
            "Country":"Bonaire, Sint Eustatius and Saba"
         }
      }
   },
   {
      "CG.cn.BIH":{
         "Content Source Geo":{
            "Country":"Bosnia and Herzegovina"
         }
      }
   },
   {
      "CG.cn.BWA":{
         "Content Source Geo":{
            "Country":"Botswana"
         }
      }
   },
   {
      "CG.cn.BVT":{
         "Content Source Geo":{
            "Country":"Bouvet Island"
         }
      }
   },
   {
      "CG.cn.BRA":{
         "Content Source Geo":{
            "Country":"Brazil"
         }
      }
   },
   {
      "CG.cn.VGB":{
         "Content Source Geo":{
            "Country":"British Virgin Islands"
         }
      }
   },
   {
      "CG.cn.BRN":{
         "Content Source Geo":{
            "Country":"Brunei Darussalam"
         }
      }
   },
   {
      "CG.cn.BGR":{
         "Content Source Geo":{
            "Country":"Bulgaria"
         }
      }
   },
   {
      "CG.cn.BFA":{
         "Content Source Geo":{
            "Country":"Burkina Faso"
         }
      }
   },
   {
      "CG.cn.BDI":{
         "Content Source Geo":{
            "Country":"Burundi"
         }
      }
   },
   {
      "CG.cn.CPV":{
         "Content Source Geo":{
            "Country":"Cabo Verde"
         }
      }
   },
   {
      "CG.cn.KHM":{
         "Content Source Geo":{
            "Country":"Cambodia"
         }
      }
   },
   {
      "CG.cn.CMR":{
         "Content Source Geo":{
            "Country":"Cameroon"
         }
      }
   },
   {
      "CG.cn.CAN":{
         "Content Source Geo":{
            "Country":"Canada"
         }
      }
   },
   {
      "CG.cn.TCD":{
         "Content Source Geo":{
            "Country":"Chad"
         }
      }
   },
   {
      "CG.cn.CHL":{
         "Content Source Geo":{
            "Country":"Chile"
         }
      }
   },
   {
      "CG.cn.CHN":{
         "Content Source Geo":{
            "Country":"China"
         }
      }
   },
   {
      "CG.cn.CXR":{
         "Content Source Geo":{
            "Country":"Christmas Island"
         }
      }
   },
   {
      "CG.cn.COL":{
         "Content Source Geo":{
            "Country":"Colombia"
         }
      }
   },
   {
      "CG.cn.CRI":{
         "Content Source Geo":{
            "Country":"Costa Rica"
         }
      }
   },
   {
      "CG.cn.CRV":{
         "Content Source Geo":{
            "Country":"Cote d'Ivoire"
         }
      }
   },
   {
      "CG.cn.HRV":{
         "Content Source Geo":{
            "Country":"Croatia"
         }
      }
   },
   {
      "CG.cn.CUB":{
         "Content Source Geo":{
            "Country":"Cuba"
         }
      }
   },
   {
      "CG.cn.CUW":{
         "Content Source Geo":{
            "Country":"Curaçao"
         }
      }
   },
   {
      "CG.cn.CYP":{
         "Content Source Geo":{
            "Country":"Cyprus"
         }
      }
   },
   {
      "CG.cn.CZE":{
         "Content Source Geo":{
            "Country":"Czechia"
         }
      }
   },
   {
      "CG.cn.DNK":{
         "Content Source Geo":{
            "Country":"Denmark"
         }
      }
   },
   {
      "CG.cn.DJI":{
         "Content Source Geo":{
            "Country":"Djibouti"
         }
      }
   },
   {
      "CG.cn.DMA":{
         "Content Source Geo":{
            "Country":"Dominica"
         }
      }
   },
   {
      "CG.cn.ECU":{
         "Content Source Geo":{
            "Country":"Ecuador"
         }
      }
   },
   {
      "CG.cn.EGY":{
         "Content Source Geo":{
            "Country":"Egypt"
         }
      }
   },
   {
      "CG.cn.SLV":{
         "Content Source Geo":{
            "Country":"El Salvador"
         }
      }
   },
   {
      "CG.cn.GNQ":{
         "Content Source Geo":{
            "Country":"Equatorial Guinea"
         }
      }
   },
   {
      "CG.cn.ERI":{
         "Content Source Geo":{
            "Country":"Eritrea"
         }
      }
   },
   {
      "CG.cn.EST":{
         "Content Source Geo":{
            "Country":"Estonia"
         }
      }
   },
   {
      "CG.cn.ETH":{
         "Content Source Geo":{
            "Country":"Ethiopia"
         }
      }
   },
   {
      "CG.cn.FSM":{
         "Content Source Geo":{
            "Country":"Federated States of Micronesia"
         }
      }
   },
   {
      "CG.cn.FJI":{
         "Content Source Geo":{
            "Country":"Fiji"
         }
      }
   },
   {
      "CG.cn.FIN":{
         "Content Source Geo":{
            "Country":"Finland"
         }
      }
   },
   {
      "CG.cn.FRA":{
         "Content Source Geo":{
            "Country":"France"
         }
      }
   },
   {
      "CG.cn.GUF":{
         "Content Source Geo":{
            "Country":"French Guiana"
         }
      }
   },
   {
      "CG.cn.PYF":{
         "Content Source Geo":{
            "Country":"French Polynesia"
         }
      }
   },
   {
      "CG.cn.GAB":{
         "Content Source Geo":{
            "Country":"Gabon"
         }
      }
   },
   {
      "CG.cn.GEO":{
         "Content Source Geo":{
            "Country":"Georgia"
         }
      }
   },
   {
      "CG.cn.DEU":{
         "Content Source Geo":{
            "Country":"Germany"
         }
      }
   },
   {
      "CG.cn.GHA":{
         "Content Source Geo":{
            "Country":"Ghana"
         }
      }
   },
   {
      "CG.cn.GIB":{
         "Content Source Geo":{
            "Country":"Gibraltar"
         }
      }
   },
   {
      "CG.cn.GRC":{
         "Content Source Geo":{
            "Country":"Greece"
         }
      }
   },
   {
      "CG.cn.GRL":{
         "Content Source Geo":{
            "Country":"Greenland"
         }
      }
   },
   {
      "CG.cn.GRD":{
         "Content Source Geo":{
            "Country":"Grenada"
         }
      }
   },
   {
      "CG.cn.GLP":{
         "Content Source Geo":{
            "Country":"Guadeloupe"
         }
      }
   },
   {
      "CG.cn.GUM":{
         "Content Source Geo":{
            "Country":"Guam"
         }
      }
   },
   {
      "CG.cn.GTM":{
         "Content Source Geo":{
            "Country":"Guatemala"
         }
      }
   },
   {
      "CG.cn.GGY":{
         "Content Source Geo":{
            "Country":"Guernsey"
         }
      }
   },
   {
      "CG.cn.GIN":{
         "Content Source Geo":{
            "Country":"Guinea"
         }
      }
   },
   {
      "CG.cn.GNB":{
         "Content Source Geo":{
            "Country":"Guinea-Bissau"
         }
      }
   },
   {
      "CG.cn.GUY":{
         "Content Source Geo":{
            "Country":"Guyana"
         }
      }
   },
   {
      "CG.cn.HTI":{
         "Content Source Geo":{
            "Country":"Haiti"
         }
      }
   },
   {
      "CG.cn.HMD":{
         "Content Source Geo":{
            "Country":"Heard Island and McDonald Islands"
         }
      }
   },
   {
      "CG.cn.HND":{
         "Content Source Geo":{
            "Country":"Honduras"
         }
      }
   },
   {
      "CG.cn.HKG":{
         "Content Source Geo":{
            "Country":"Hong Kong"
         }
      }
   },
   {
      "CG.cn.HUN":{
         "Content Source Geo":{
            "Country":"Hungary"
         }
      }
   },
   {
      "CG.cn.ISL":{
         "Content Source Geo":{
            "Country":"Iceland"
         }
      }
   },
   {
      "CG.cn.IND":{
         "Content Source Geo":{
            "Country":"India"
         }
      }
   },
   {
      "CG.cn.IDN":{
         "Content Source Geo":{
            "Country":"Indonesia"
         }
      }
   },
   {
      "CG.cn.IRQ":{
         "Content Source Geo":{
            "Country":"Iraq"
         }
      }
   },
   {
      "CG.cn.IRL":{
         "Content Source Geo":{
            "Country":"Ireland"
         }
      }
   },
   {
      "CG.cn.IRN":{
         "Content Source Geo":{
            "Country":"Islamic Republic of Iran"
         }
      }
   },
   {
      "CG.cn.IMN":{
         "Content Source Geo":{
            "Country":"Isle of Man"
         }
      }
   },
   {
      "CG.cn.ISR":{
         "Content Source Geo":{
            "Country":"Israel"
         }
      }
   },
   {
      "CG.cn.ITA":{
         "Content Source Geo":{
            "Country":"Italy"
         }
      }
   },
   {
      "CG.cn.JAM":{
         "Content Source Geo":{
            "Country":"Jamaica"
         }
      }
   },
   {
      "CG.cn.JPN":{
         "Content Source Geo":{
            "Country":"Japan"
         }
      }
   },
   {
      "CG.cn.JEY":{
         "Content Source Geo":{
            "Country":"Jersey"
         }
      }
   },
   {
      "CG.cn.JOR":{
         "Content Source Geo":{
            "Country":"Jordan"
         }
      }
   },
   {
      "CG.cn.KAZ":{
         "Content Source Geo":{
            "Country":"Kazakhstan"
         }
      }
   },
   {
      "CG.cn.KEN":{
         "Content Source Geo":{
            "Country":"Kenya"
         }
      }
   },
   {
      "CG.cn.KIR":{
         "Content Source Geo":{
            "Country":"Kiribati"
         }
      }
   },
   {
      "CG.cn.KWT":{
         "Content Source Geo":{
            "Country":"Kuwait"
         }
      }
   },
   {
      "CG.cn.KGZ":{
         "Content Source Geo":{
            "Country":"Kyrgyzstan"
         }
      }
   },
   {
      "CG.cn.LVA":{
         "Content Source Geo":{
            "Country":"Latvia"
         }
      }
   },
   {
      "CG.cn.LBN":{
         "Content Source Geo":{
            "Country":"Lebanon"
         }
      }
   },
   {
      "CG.cn.LSO":{
         "Content Source Geo":{
            "Country":"Lesotho"
         }
      }
   },
   {
      "CG.cn.LBR":{
         "Content Source Geo":{
            "Country":"Liberia"
         }
      }
   },
   {
      "CG.cn.LBY":{
         "Content Source Geo":{
            "Country":"Libya"
         }
      }
   },
   {
      "CG.cn.LIE":{
         "Content Source Geo":{
            "Country":"Liechtenstein"
         }
      }
   },
   {
      "CG.cn.LTU":{
         "Content Source Geo":{
            "Country":"Lithuania"
         }
      }
   },
   {
      "CG.cn.LUX":{
         "Content Source Geo":{
            "Country":"Luxembourg"
         }
      }
   },
   {
      "CG.cn.MAC":{
         "Content Source Geo":{
            "Country":"Macao"
         }
      }
   },
   {
      "CG.cn.MDG":{
         "Content Source Geo":{
            "Country":"Madagascar"
         }
      }
   },
   {
      "CG.cn.MWI":{
         "Content Source Geo":{
            "Country":"Malawi"
         }
      }
   },
   {
      "CG.cn.MYS":{
         "Content Source Geo":{
            "Country":"Malaysia"
         }
      }
   },
   {
      "CG.cn.MDV":{
         "Content Source Geo":{
            "Country":"Maldives"
         }
      }
   },
   {
      "CG.cn.MLI":{
         "Content Source Geo":{
            "Country":"Mali"
         }
      }
   },
   {
      "CG.cn.MLT":{
         "Content Source Geo":{
            "Country":"Malta"
         }
      }
   },
   {
      "CG.cn.MTQ":{
         "Content Source Geo":{
            "Country":"Martinique"
         }
      }
   },
   {
      "CG.cn.MRT":{
         "Content Source Geo":{
            "Country":"Mauritania"
         }
      }
   },
   {
      "CG.cn.MUS":{
         "Content Source Geo":{
            "Country":"Mauritius"
         }
      }
   },
   {
      "CG.cn.MYT":{
         "Content Source Geo":{
            "Country":"Mayotte"
         }
      }
   },
   {
      "CG.cn.MEX":{
         "Content Source Geo":{
            "Country":"Mexico"
         }
      }
   },
   {
      "CG.cn.MCO":{
         "Content Source Geo":{
            "Country":"Monaco"
         }
      }
   },
   {
      "CG.cn.MNG":{
         "Content Source Geo":{
            "Country":"Mongolia"
         }
      }
   },
   {
      "CG.cn.MNE":{
         "Content Source Geo":{
            "Country":"Montenegro"
         }
      }
   },
   {
      "CG.cn.MSR":{
         "Content Source Geo":{
            "Country":"Montserrat"
         }
      }
   },
   {
      "CG.cn.MAR":{
         "Content Source Geo":{
            "Country":"Morocco"
         }
      }
   },
   {
      "CG.cn.MOZ":{
         "Content Source Geo":{
            "Country":"Mozambique"
         }
      }
   },
   {
      "CG.cn.MMR":{
         "Content Source Geo":{
            "Country":"Myanmar"
         }
      }
   },
   {
      "CG.cn.NAM":{
         "Content Source Geo":{
            "Country":"Namibia"
         }
      }
   },
   {
      "CG.cn.NRU":{
         "Content Source Geo":{
            "Country":"Nauru"
         }
      }
   },
   {
      "CG.cn.NPL":{
         "Content Source Geo":{
            "Country":"Nepal"
         }
      }
   },
   {
      "CG.cn.NCL":{
         "Content Source Geo":{
            "Country":"New Caledonia"
         }
      }
   },
   {
      "CG.cn.NZL":{
         "Content Source Geo":{
            "Country":"New Zealand"
         }
      }
   },
   {
      "CG.cn.NIC":{
         "Content Source Geo":{
            "Country":"Nicaragua"
         }
      }
   },
   {
      "CG.cn.NGA":{
         "Content Source Geo":{
            "Country":"Nigeria"
         }
      }
   },
   {
      "CG.cn.NIU":{
         "Content Source Geo":{
            "Country":"Niue"
         }
      }
   },
   {
      "CG.cn.NFK":{
         "Content Source Geo":{
            "Country":"Norfolk Island"
         }
      }
   },
   {
      "CG.cn.NOR":{
         "Content Source Geo":{
            "Country":"Norway"
         }
      }
   },
   {
      "CG.cn.OMN":{
         "Content Source Geo":{
            "Country":"Oman"
         }
      }
   },
   {
      "CG.cn.PAK":{
         "Content Source Geo":{
            "Country":"Pakistan"
         }
      }
   },
   {
      "CG.cn.PLW":{
         "Content Source Geo":{
            "Country":"Palau"
         }
      }
   },
   {
      "CG.cn.PAN":{
         "Content Source Geo":{
            "Country":"Panama"
         }
      }
   },
   {
      "CG.cn.PNG":{
         "Content Source Geo":{
            "Country":"Papua New Guinea"
         }
      }
   },
   {
      "CG.cn.PRY":{
         "Content Source Geo":{
            "Country":"Paraguay"
         }
      }
   },
   {
      "CG.cn.PER":{
         "Content Source Geo":{
            "Country":"Peru"
         }
      }
   },
   {
      "CG.cn.PCN":{
         "Content Source Geo":{
            "Country":"Pitcairn"
         }
      }
   },
   {
      "CG.cn.POL":{
         "Content Source Geo":{
            "Country":"Poland"
         }
      }
   },
   {
      "CG.cn.PRT":{
         "Content Source Geo":{
            "Country":"Portugal"
         }
      }
   },
   {
      "CG.cn.PRI":{
         "Content Source Geo":{
            "Country":"Puerto Rico"
         }
      }
   },
   {
      "CG.cn.QAT":{
         "Content Source Geo":{
            "Country":"Qatar"
         }
      }
   },
   {
      "CG.cn.REU":{
         "Content Source Geo":{
            "Country":"Reunion"
         }
      }
   },
   {
      "CG.cn.ROU":{
         "Content Source Geo":{
            "Country":"Romania"
         }
      }
   },
   {
      "CG.cn.RWA":{
         "Content Source Geo":{
            "Country":"Rwanda"
         }
      }
   },
   {
      "CG.cn.BLM":{
         "Content Source Geo":{
            "Country":"Saint Barthelemy"
         }
      }
   },
   {
      "CG.cn.SHN":{
         "Content Source Geo":{
            "Country":"Saint Helena, Ascension and Tristan da Cunha"
         }
      }
   },
   {
      "CG.cn.KNA":{
         "Content Source Geo":{
            "Country":"Saint Kitts and Nevis"
         }
      }
   },
   {
      "CG.cn.LCA":{
         "Content Source Geo":{
            "Country":"Saint Lucia"
         }
      }
   },
   {
      "CG.cn.MAF":{
         "Content Source Geo":{
            "Country":"Saint Martin"
         }
      }
   },
   {
      "CG.cn.SPM":{
         "Content Source Geo":{
            "Country":"Saint Pierre and Miquelon"
         }
      }
   },
   {
      "CG.cn.VCT":{
         "Content Source Geo":{
            "Country":"Saint Vincent and the Grenadines"
         }
      }
   },
   {
      "CG.cn.WSM":{
         "Content Source Geo":{
            "Country":"Samoa"
         }
      }
   },
   {
      "CG.cn.SMR":{
         "Content Source Geo":{
            "Country":"San Marino"
         }
      }
   },
   {
      "CG.cn.STP":{
         "Content Source Geo":{
            "Country":"Sao Tome and Principe"
         }
      }
   },
   {
      "CG.cn.SAU":{
         "Content Source Geo":{
            "Country":"Saudi Arabia"
         }
      }
   },
   {
      "CG.cn.SEN":{
         "Content Source Geo":{
            "Country":"Senegal"
         }
      }
   },
   {
      "CG.cn.SRB":{
         "Content Source Geo":{
            "Country":"Serbia"
         }
      }
   },
   {
      "CG.cn.SYC":{
         "Content Source Geo":{
            "Country":"Seychelles"
         }
      }
   },
   {
      "CG.cn.SLE":{
         "Content Source Geo":{
            "Country":"Sierra Leone"
         }
      }
   },
   {
      "CG.cn.SGP":{
         "Content Source Geo":{
            "Country":"Singapore"
         }
      }
   },
   {
      "CG.cn.SXM":{
         "Content Source Geo":{
            "Country":"Sint Maarten"
         }
      }
   },
   {
      "CG.cn.SVK":{
         "Content Source Geo":{
            "Country":"Slovakia"
         }
      }
   },
   {
      "CG.cn.SVN":{
         "Content Source Geo":{
            "Country":"Slovenia"
         }
      }
   },
   {
      "CG.cn.SLB":{
         "Content Source Geo":{
            "Country":"Solomon Islands"
         }
      }
   },
   {
      "CG.cn.SOM":{
         "Content Source Geo":{
            "Country":"Somalia"
         }
      }
   },
   {
      "CG.cn.ZAF":{
         "Content Source Geo":{
            "Country":"South Africa"
         }
      }
   },
   {
      "CG.cn.SGS":{
         "Content Source Geo":{
            "Country":"South Georgia and the South Sandwich Islands"
         }
      }
   },
   {
      "CG.cn.SSD":{
         "Content Source Geo":{
            "Country":"South Sudan"
         }
      }
   },
   {
      "CG.cn.ESP":{
         "Content Source Geo":{
            "Country":"Spain"
         }
      }
   },
   {
      "CG.cn.LKA":{
         "Content Source Geo":{
            "Country":"Sri Lanka"
         }
      }
   },
   {
      "CG.cn.PSE":{
         "Content Source Geo":{
            "Country":"State of Palestine"
         }
      }
   },
   {
      "CG.cn.SUR":{
         "Content Source Geo":{
            "Country":"Suriname"
         }
      }
   },
   {
      "CG.cn.SJM":{
         "Content Source Geo":{
            "Country":"Svalbard and Jan Mayen"
         }
      }
   },
   {
      "CG.cn.SWZ":{
         "Content Source Geo":{
            "Country":"Swaziland"
         }
      }
   },
   {
      "CG.cn.SWE":{
         "Content Source Geo":{
            "Country":"Sweden"
         }
      }
   },
   {
      "CG.cn.CHE":{
         "Content Source Geo":{
            "Country":"Switzerland"
         }
      }
   },
   {
      "CG.cn.SYR":{
         "Content Source Geo":{
            "Country":"Syrian Arab Republic"
         }
      }
   },
   {
      "CG.cn.TWN":{
         "Content Source Geo":{
            "Country":"Taiwan (Province of China)"
         }
      }
   },
   {
      "CG.cn.TJK":{
         "Content Source Geo":{
            "Country":"Tajikistan"
         }
      }
   },
   {
      "CG.cn.THA":{
         "Content Source Geo":{
            "Country":"Thailand"
         }
      }
   },
   {
      "CG.cn.BHS":{
         "Content Source Geo":{
            "Country":"The Bahamas"
         }
      }
   },
   {
      "CG.cn.IOT":{
         "Content Source Geo":{
            "Country":"The British Indian Ocean Territory"
         }
      }
   },
   {
      "CG.cn.CYM":{
         "Content Source Geo":{
            "Country":"The Cayman Islands"
         }
      }
   },
   {
      "CG.cn.CAF":{
         "Content Source Geo":{
            "Country":"The Central African Republic"
         }
      }
   },
   {
      "CG.cn.CCK":{
         "Content Source Geo":{
            "Country":"The Cocos Islands"
         }
      }
   },
   {
      "CG.cn.COM":{
         "Content Source Geo":{
            "Country":"The Comoros"
         }
      }
   },
   {
      "CG.cn.COG":{
         "Content Source Geo":{
            "Country":"The Congo"
         }
      }
   },
   {
      "CG.cn.COK":{
         "Content Source Geo":{
            "Country":"The Cook Islands"
         }
      }
   },
   {
      "CG.cn.PRK":{
         "Content Source Geo":{
            "Country":"The Democratic People's Republic of Korea"
         }
      }
   },
   {
      "CG.cn.COD":{
         "Content Source Geo":{
            "Country":"the Democratic Republic of the Congo "
         }
      }
   },
   {
      "CG.cn.DOM":{
         "Content Source Geo":{
            "Country":"The Dominican Republic"
         }
      }
   },
   {
      "CG.cn.FLK":{
         "Content Source Geo":{
            "Country":"The Falkland Islands"
         }
      }
   },
   {
      "CG.cn.FRO":{
         "Content Source Geo":{
            "Country":"The Faroe Islands"
         }
      }
   },
   {
      "CG.cn.MKD":{
         "Content Source Geo":{
            "Country":"The former Yugoslav Republic of Macedonia"
         }
      }
   },
   {
      "CG.cn.ATF":{
         "Content Source Geo":{
            "Country":"The French Southern Territories"
         }
      }
   },
   {
      "CG.cn.GMB":{
         "Content Source Geo":{
            "Country":"The Gambia"
         }
      }
   },
   {
      "CG.cn.VAT":{
         "Content Source Geo":{
            "Country":"The Holy See"
         }
      }
   },
   {
      "CG.cn.LAO":{
         "Content Source Geo":{
            "Country":"The Lao People's Democratic Republic"
         }
      }
   },
   {
      "CG.cn.MHL":{
         "Content Source Geo":{
            "Country":"The Marshall Islands"
         }
      }
   },
   {
      "CG.cn.NLD":{
         "Content Source Geo":{
            "Country":"The Netherlands"
         }
      }
   },
   {
      "CG.cn.NER":{
         "Content Source Geo":{
            "Country":"The Niger"
         }
      }
   },
   {
      "CG.cn.MNP":{
         "Content Source Geo":{
            "Country":"The Northern Mariana Islands"
         }
      }
   },
   {
      "CG.cn.PHL":{
         "Content Source Geo":{
            "Country":"The Philippines"
         }
      }
   },
   {
      "CG.cn.KOR":{
         "Content Source Geo":{
            "Country":"The Republic of Korea"
         }
      }
   },
   {
      "CG.cn.MDA":{
         "Content Source Geo":{
            "Country":"The Republic of Moldova"
         }
      }
   },
   {
      "CG.cn.RUS":{
         "Content Source Geo":{
            "Country":"The Russian Federation"
         }
      }
   },
   {
      "CG.cn.SDN":{
         "Content Source Geo":{
            "Country":"The Sudan"
         }
      }
   },
   {
      "CG.cn.TCA":{
         "Content Source Geo":{
            "Country":"The Turks and Caicos Islands"
         }
      }
   },
   {
      "CG.cn.ARE":{
         "Content Source Geo":{
            "Country":"The United Arab Emirates"
         }
      }
   },
   {
      "CG.cn.GBR":{
         "Content Source Geo":{
            "Country":"The United Kingdom of Great Britain and Northern Ireland"
         }
      }
   },
   {
      "CG.cn.UMI":{
         "Content Source Geo":{
            "Country":"The United States Minor Outlying Islands"
         }
      }
   },
   {
      "CG.cn.USA":{
         "Content Source Geo":{
            "Country":"The United States of America"
         }
      }
   },
   {
      "CG.cn.TLS":{
         "Content Source Geo":{
            "Country":"Timor-Leste"
         }
      }
   },
   {
      "CG.cn.TGO":{
         "Content Source Geo":{
            "Country":"Togo"
         }
      }
   },
   {
      "CG.cn.TKL":{
         "Content Source Geo":{
            "Country":"Tokelau"
         }
      }
   },
   {
      "CG.cn.TON":{
         "Content Source Geo":{
            "Country":"Tonga"
         }
      }
   },
   {
      "CG.cn.TTO":{
         "Content Source Geo":{
            "Country":"Trinidad and Tobago"
         }
      }
   },
   {
      "CG.cn.TUN":{
         "Content Source Geo":{
            "Country":"Tunisia"
         }
      }
   },
   {
      "CG.cn.TUR":{
         "Content Source Geo":{
            "Country":"Turkey"
         }
      }
   },
   {
      "CG.cn.TKM":{
         "Content Source Geo":{
            "Country":"Turkmenistan"
         }
      }
   },
   {
      "CG.cn.TUV":{
         "Content Source Geo":{
            "Country":"Tuvalu"
         }
      }
   },
   {
      "CG.cn.VIR":{
         "Content Source Geo":{
            "Country":"U.S. Virgin Islands"
         }
      }
   },
   {
      "CG.cn.UGA":{
         "Content Source Geo":{
            "Country":"Uganda"
         }
      }
   },
   {
      "CG.cn.UKR":{
         "Content Source Geo":{
            "Country":"Ukraine"
         }
      }
   },
   {
      "CG.cn.TZA":{
         "Content Source Geo":{
            "Country":"United Republic of Tanzania"
         }
      }
   },
   {
      "CG.cn.URY":{
         "Content Source Geo":{
            "Country":"Uruguay"
         }
      }
   },
   {
      "CG.cn.UZB":{
         "Content Source Geo":{
            "Country":"Uzbekistan"
         }
      }
   },
   {
      "CG.cn.VUT":{
         "Content Source Geo":{
            "Country":"Vanuatu"
         }
      }
   },
   {
      "CG.cn.VNM":{
         "Content Source Geo":{
            "Country":"Vietnam"
         }
      }
   },
   {
      "CG.cn.WLF":{
         "Content Source Geo":{
            "Country":"Wallis and Futuna"
         }
      }
   },
   {
      "CG.cn.ESH":{
         "Content Source Geo":{
            "Country":"Western Sahara"
         }
      }
   },
   {
      "CG.cn.YEM":{
         "Content Source Geo":{
            "Country":"Yemen"
         }
      }
   },
   {
      "CG.cn.ZMB":{
         "Content Source Geo":{
            "Country":"Zambia"
         }
      }
   },
   {
      "CG.cn.ZWE":{
         "Content Source Geo":{
            "Country":"Zimbabwe"
         }
      }
   },
   {
      "CG.rg":{
         "Content Source Geo":"Region/State"
      }
   },
   {
      "CG.me":{
         "Content Source Geo":"Metro"
      }
   },
   {
      "CG.cy":{
         "Content Source Geo":"City"
      }
   }
];


// WEBPACK FOOTER //
// ./src/assets/data/taxonomies/index.js